<template>
    <div class="tyn-root" :style="{ '--appbarnav-height': appbarNavHeight + 'px' }">
        <Header ref="header"></Header>
        <template v-if="showLockRegistro">
            <div class="tyn-content tyn-content-page lock-registro-page">
                <div class="lock-registro-container">
                    <div class="lock-registro-card-inner">
                        <div class="lock-registro-header">
                            <div class="lock-registro-header-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <circle cx="12" cy="12" r="10" />
                                    <polyline points="12 6 12 12 16 14" />
                                </svg>
                            </div>
                            <div class="lock-registro-header-text">
                                <h2 class="lock-registro-title">Registro de Necessidade pendente</h2>
                                <p class="lock-registro-desc">
                                    Este processo está <strong>aguardando</strong> o Registro de Necessidade.
                                    Enquanto isso, fica <strong>somente para visualização</strong>.
                                </p>
                            </div>
                        </div>
                        <div class="lock-registro-content">
                            <div class="row">
                                <div class="col-9 col-md-3">
                                    <div>
                                        <label class="form-label">Data de limite</label>
                                        <input type="date" class="form-control"
                                               v-model="dtLimiteRegistroNecessidade" />
                                    </div>
                                    
                                </div>
                                <div class="col-3 d-flex align-items-end">
                                    <button type="button"
                                         @click="confirmarAtualizarDataLimite()"
                                        class="lock-registro-btn-primary">Atualizar</button>
                                </div>
                                

                            </div>
                            <div class="row">
                                <div class="col-12 col-md-3">
                                    <div class="form-grid form-group-inline mt-2">
                                        <div class="info-chip w-100 align-items-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                                <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 .876-.252 1.02-.598l.088-.416c.066-.3.104-.378.288-.41l.451-.083.082-.38-1.428-.287.545-2.545z" />
                                                <circle cx="8" cy="4.5" r="1" />
                                            </svg>
                                            O Processo só poderá ser iniciado após a Data de limite.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div v-if="registroItensLoading" class="lock-registro-loading">
                            <span class="spinner-border spinner-border-sm me-2"></span>
                            Carregando itens...
                        </div>

                        <div v-else class="lock-registro-content">
                            <div v-if="!isLoteUnico" class="lock-registro-lotes-bar mb-3 d-flex align-items-center gap-2 flex-wrap">
                                <span class="fw-bold">Lotes disponíveis:</span>

                                <span v-for="l in registroLotes"
                                      :key="'chip-lote-' + l.idProcessoItemLote"
                                      :class="'badge rounded-pill  text-dark border' + (l.idProcessoItemLote != loteSelecionado? ' bg-light':'')"
                                      @click="loteSelecionado = l.idProcessoItemLote">
                                    Lote {{ l.nrLote }}
                                </span>
                            </div>

                            <div class="lock-registro-table-wrap">
                                <table class="lock-registro-table">
                                    <thead>
                                        <tr>
                                            <th>Item</th>
                                            <th class="text-center" style="width: 120px;">Unid.</th>
                                            <th class="text-center" style="width: 160px;">Total solicitado</th>
                                            <th v-if="!isLoteUnico" class="text-center" style="width: 140px;">Lote</th>
                                            <th class="text-center" style="width: 130px;">Quantidade</th>
                                            <th class="text-center" style="width: 130px;">Ações</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr v-for="(it, i) in registroItens.filter(x=>x.idProcessoItemLote == loteSelecionado)"
                                            :key="it.idItem + '-' + (it.idUnidadeMedida || 0) + '-' + (it.idProcessoItemLoteSelecionado || 0) + '-' + i">
                                            <td>
                                                <div class="lock-registro-item-name">
                                                    {{ it.nmItem || ('Item ' + it.idItem) }}
                                                </div>
                                                <div class="lock-registro-item-ref">
                                                    {{ it.cdReferencia || it.cdItem || '-' }}
                                                    <span v-if="it.tpItem"> • {{ it.tpItem }}</span>
                                                </div>
                                            </td>

                                            <td class="text-center">
                                                {{ it.nmUnidadeMedida || it.cdUnidadeMedida || '-' }}
                                            </td>

                                            <td class="text-center">
                                                <span class="lock-registro-badge">
                                                    {{ formatQtd(it.qtdTotalItem) }}
                                                </span>
                                            </td>

                                            <td v-if="!isLoteUnico" class="text-center">
                                                Lote {{registroLotes.find(x=>x.idProcessoItemLote=== it.idProcessoItemLote)?.nrLote}}
                                            </td>

                                            <!-- Quantidade -->
                                            <td class="text-center">
                                                <input type="number"
                                                       class="lock-registro-input form-control form-control-sm text-end"
                                                       v-model.number="it.qtdTotalItemUtilizada"
                                                       :min="0"
                                                       :max="Number(it.qtdTotalItemUtilizada || 0)"
                                                       disabled
                                                       step="any"
                                                       placeholder="0"
                                                       @blur="ajustarQtdIniciar(it)" />
                                            </td>

                                            <td class="text-end">
                                                <button type="button"
                                                        class="lock-registro-btn-action"
                                                        @click="abrirDetalhesItem(it)">
                                                    Detalhes
                                                </button>
                                            </td>
                                        </tr>

                                        <tr v-if="!registroItens.length">
                                            <td :colspan="!isLoteUnico ? 6 : 5"
                                                class="lock-registro-empty">
                                                <div class="lock-registro-empty-content">
                                                    <h3>Nenhum item encontrado</h3>
                                                    <p>Não há itens para este processo no momento.</p>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="lock-registro-footer">
                                <button type="button"
                                        class="lock-registro-btn-primary"
                                        @click="confirmarIniciarProcesso()"
                                        :disabled="registroItensLoading || registroIniciando || !registroPodeIniciar">
                                    <span v-if="registroIniciando" class="spinner-border spinner-border-sm me-2"></span>
                                    Iniciar processo
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <template v-else>
            <template v-if="processo && processo.idProcesso != null">
                <div class="navegacao-artefatos" ref="navBar">
                    <div class="container-fluid px-2">
                        <div class="bg-white row py-2 align-items-center g-2">
                            <div class="col-12 col-xl-9">
                                <div class="artefato-scroll-wrapper w-100" style="position: relative;">
                                    <button class="scroll-btn left" v-if="podeScrollEsquerda" @click="scrollEsquerda">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
                                        </svg>
                                    </button>

                                    <div class="artefato-container" ref="scrollContainer">
                                        <CardArtefato v-for="(item, index) in artefatosOrdenados"
                                                      :key="item.idProcessoModeloArtefato"
                                                      :nmModelo="item.nmModelo"
                                                      :icone="item.icone"
                                                      :flEnviado="item.flArtefatoFinalizado"
                                                      :flRetificado="item.flRetificado"
                                                      :nmUsuario="item.nmUsuario"
                                                      :dtLimite="item.dataLimiteDate"
                                                      :isAtual="index === indexAtual"
                                                      :bloqueado="item.bloqueado"
                                                      :title="tooltipDependencias(item.idProcessoModeloArtefato)"
                                                      @click="exibeModalProcessoArtefato(item.idProcessoModeloArtefato)" />
                                    </div>

                                    <button class="scroll-btn right" v-if="podeScrollDireita" @click="scrollDireita">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                            <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 col-xl-3">
                                <div class="card h-100" style="margin: 0;">
                                    <div class="card-body d-flex flex-column gap-2 p-1">
                                        <div class="d-flex align-items-start justify-content-between gap-2 flex-nowrap">
                                            <div class="flex-grow-1 min-w-0 position-relative overflow-hidden" style="z-index: 0; max-width: calc(100% - 110px);">
                                                <div class="tyn-media-group">
                                                    <div class="tyn-media-col">
                                                        <div class="tyn-media-row">
                                                            <h3 class="name txt-bold m-0 text-truncate nome-processo-hover w-100"
                                                                @mouseenter="mostrarTooltipNumeroProcesso"
                                                                @mouseleave="ocultarTooltipNumeroProcesso">
                                                                Processo N.º <span class="numero-processo-destaque">{{ processo?.cdProcesso || '-' }}</span>
                                                            </h3>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="tyn-media-group mb-1">
                                                    <div class="tyn-media-col">
                                                        <div class="tyn-media-row">
                                                            <h6 class="name text-truncate nome-processo-hover"
                                                                style="font-weight: 200 !important; padding: 1px 0 !important; max-width: 100%;"
                                                                :title="processo?.dsNome || '-'">
                                                                <span>{{ processo?.dsNome || '-' }}</span>
                                                            </h6>
                                                        </div>
                                                    </div>
                                                </div>
                                                <span class="badge-subtle me-1 mb-1" v-if="processoLegislacao">{{ processoLegislacao.dsNome }}</span>
                                                <span class="badge-subtle mb-0" v-if="processoTipoProcesso">{{ processoTipoProcesso.nmTipoProcesso }}</span>
                                                <span class="badge-subtle badge-finalizado ms-1 mb-1" v-if="processo?.flFinalizado == true">FINALIZADO</span>
                                            </div>
                                            <div class="d-flex gap-1 flex-wrap justify-content-end flex-shrink-0" style="min-width: 90px; z-index: 1; position: relative;">
                                                <div class="d-flex gap-1 flex-wrap justify-content-end">
                                                    <button class="btn btn-primary btn-chamativo" title="Lista de Itens" @click="abrirModalItem" v-if="verificaPermissao('IT')">
                                                        Itens
                                                    </button>
                                                    <div class="dropdown">
                                                        <button class="btn btn-icon btn-primary btn-icon-chamativo dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" title="Mais Opções">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                                                <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                                            </svg>
                                                        </button>
                                                        <div class="dropdown-menu dropdown-menu-modern dropdown-menu-end px-3" style="min-width: 250px;">
                                                            <ul class="tyn-list-links">
                                                                <li>
                                                                    <a href="javascript:void(0)" @click="abrirModalEditarNome" v-if="flProprietario">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="bi bi-pencil-square icon-link" viewBox="0 0 16 16">
                                                                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                                                            <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                                                                        </svg>
                                                                        <span>Editar</span>
                                                                    </a>
                                                                    <a href="javascript:void(0)" @click="abrirModalProcessoNorma" v-if="flProprietario">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" class="bi bi-database-up icon-link">
                                                                            <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.354-5.854 1.5 1.5a.5.5 0 0 1-.708.708L13 11.707V14.5a.5.5 0 0 1-1 0v-2.793l-.646.647a.5.5 0 0 1-.708-.708l1.5-1.5a.5.5 0 0 1 .708 0"></path>
                                                                            <path d="M12.096 6.223A5 5 0 0 0 13 5.698V7c0 .289-.213.654-.753 1.007a4.5 4.5 0 0 1 1.753.25V4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.5 4.5 0 0 1-.813-.927Q8.378 15 8 15c-1.464 0-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13h.027a4.6 4.6 0 0 1 0-1H8c-1.464 0-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10q.393 0 .774-.024a4.5 4.5 0 0 1 1.102-1.132C9.298 8.944 8.666 9 8 9c-1.464 0-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777M3 4c0-.374.356-.875 1.318-1.313C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4"></path>
                                                                        </svg>
                                                                        <span>Normativas</span>
                                                                    </a>
                                                                    <a href="javascript:void(0)" @click="baixarDocumentosZip">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="bi bi-file-earmark-zip icon-link" viewBox="0 0 14 16">
                                                                            <path d="M5 7.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v.938l.4 1.599a1 1 0 0 1-.416 1.074l-.93.62a1 1 0 0 1-1.11 0l-.929-.62a1 1 0 0 1-.415-1.074L5 8.438zm2 0H6v.938a1 1 0 0 1-.03.243l-.4 1.598.93.62.929-.62-.4-1.598A1 1 0 0 1 7 8.438z" />
                                                                            <path d="M14 4.5V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h5.5zm-3 0A1.5 1.5 0 0 1 9.5 3V1h-2v1h-1v1h1v1h-1v1h1v1H6V5H5V4h1V3H5V2h1V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4.5z" />
                                                                        </svg>
                                                                        <span>Baixar Documentos Compactados</span>
                                                                    </a>
                                                                    <a href="javascript:void(0)" @click="gerarDocumentosPdf">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" class="bi bi-file-earmark-pdf icon-link" viewBox="0 0 16 16">
                                                                            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                                                            <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" />
                                                                        </svg>
                                                                        <span>Gerar Documentos em PDF</span>
                                                                    </a>
                                                                    <a href="javascript:void(0)" @click="abrirModalProcessoPermissao" v-if="flProprietario">
                                                                        <i class="fas fa-lock"></i>
                                                                        <span>Permissões</span>
                                                                    </a>
                                                                    <a href="javascript:void(0)" @click="abrirModalRegistroNecessidade" v-if="temRegistroNecessidade">
                                                                        <i class="fas fa-shopping-cart"></i>
                                                                        <span>Registro de Necessidades</span>
                                                                    </a>
                                                                    <a href="javascript:void(0)" @click="finalizarProcesso" v-if="flProprietario && !processo?.flFinalizado">
                                                                        <i class="fas fa-clipboard-check"></i>
                                                                        <span>Finalizar</span>
                                                                    </a>

                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tyn-content tyn-contact  has-aside-base">
                    <Historico :flPermissao="verificaPermissao('PE')" :idProcesso="id.toString()" :nmComponente="'ProcessoConversa'" :reload="reload" @atualizar="novo" :seleciona="seleciona" :novo="novo" :id="idProcessoConversa"></Historico>
                    <div class="tyn-main tyn-content-inner" id="tynMain">
                        <ul class="tyn-list-inline d-md-none translate-middle-x position-absolute start-50 z-1">
                            <li>
                                <button class="btn btn-icon btn-pill btn-white js-toggle-main" @click="fechar">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                                    </svg><!-- x-lg -->
                                </button>
                            </li>
                        </ul>
                        <template v-if="!flVerificacaoCadastroArtefato">

                            <div class="row g-3 justify-content-center">
                                <div class="col-sm-6 col-md-5 col-lg-12">
                                    <div class="card h-100 border-0">
                                        <div class="card-body">
                                            <h3 class="text-center"> <i class="fas fa-arrow-left" style="transform: rotate(45deg);"></i>  Cadastre um Artefato para realizar perguntas</h3>
                                        </div>
                                    </div><!-- .card -->
                                </div><!-- .col -->
                            </div>
                        </template>
                        <template v-else>
                            <div class="tyn-chat-body m-4 rounded-3" data-simplebar>
                                <div class="container px-0">
                                    <template v-if="idProcessoConversa == 0">
                                        <div class="tyn-qa tyn-qa-bubbly" v-if="verificaPermissao('PE')">
                                            <!-- ETAPA 0 -->
                                            <template v-if="etapa === 0 && checagensProntas">
                                                <div v-if="!utilizacoes?.permiteRealizarConversa" class="tyn-qa-item">
                                                    <div class="tyn-qa-avatar">
                                                        <div class="tyn-qa-avatar-wrap">
                                                            <div class="tyn-media tyn-size-md" style="background: transparent">
                                                                <img src="/assets/images/sollai/avatar.png" alt="">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="tyn-qa-message tyn-text-block bg-response">
                                                        <p>
                                                            Desculpe, parece que você atingiu seu limite de Perguntas do contrato.
                                                            Entre em contato com um dos nossos consultores.
                                                        </p>
                                                    </div>
                                                </div>
                                                <div v-else-if="!flRealizaPergunta" class="tyn-qa-item">
                                                    <div class="tyn-qa-avatar">
                                                        <div class="tyn-qa-avatar-wrap">
                                                            <div class="tyn-media tyn-size-md" style="background: transparent">
                                                                <img src="/assets/images/sollai/avatar.png" alt="">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="tyn-qa-message tyn-text-block bg-response">
                                                        <p>{{ msgNaoRealizaPergunta }}</p>
                                                    </div>
                                                </div>
                                                <div v-else class="tyn-qa-item">
                                                    <div class="tyn-qa-avatar">
                                                        <div class="tyn-qa-avatar-wrap">
                                                            <div class="tyn-media tyn-size-md" style="background: transparent">
                                                                <img src="/assets/images/sollai/avatar.png" alt="">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="tyn-qa-message tyn-text-block bg-response">
                                                        <p>Como posso ajudá-lo hoje?</p>
                                                    </div>
                                                </div>
                                            </template>

                                            <!-- ETAPA 1 -->
                                            <!-- FORMATO RESPOSTA -->
                                            <template v-if="etapa > 0">
                                                <div class="tyn-qa-item">
                                                    <div class="tyn-qa-avatar">
                                                        <div class="tyn-media tyn-size-md">
                                                            <template v-if="user.usuarioApi">
                                                                <img v-if="user.usuarioApi.urlImgFoto" :src="user.usuarioApi.urlImgFoto" alt="" />
                                                                <img v-else src="/assets/images/avatar/3.jpg" alt="">
                                                            </template>
                                                            <template v-else>
                                                                <img src="/assets/images/avatar/3.jpg" alt="">
                                                            </template>
                                                        </div>
                                                    </div>
                                                    <template v-if="flReprocessar">
                                                        <div class="tyn-qa-message tyn-text-block bg-question">
                                                            <div class="form-group">
                                                                <textarea class="form-control" placeholder="Digite sua pergunta" maxlength="5000" v-model="formPergunta.dsPergunta"></textarea>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <div class="tyn-qa-message tyn-text-block bg-question">{{formPergunta.dsPergunta}}</div>
                                                    </template>
                                                </div>
                                                <div class="tyn-qa-item">
                                                    <div class="tyn-qa-avatar">
                                                        <div class="tyn-qa-avatar-wrap">
                                                            <div class="tyn-media tyn-size-md" style="background: transparent">
                                                                <img src="/assets/images/sollai/avatar.png" alt="">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="tyn-qa-message tyn-text-block bg-response">
                                                        <p class="fw-bold">Escolha o formato da resposta:</p>
                                                        <div class="d-flex align-items-center mb-1 ps-3" v-for="(item,index) in lstTiposPerguntas" v-bind:key="index">
                                                            <input type="radio" :id="'huey'+ index" name="tpPergunta" :value="item.value" v-model="formPergunta.tpPergunta" :disabled="disabled" />
                                                            <label class="ps-2" :for="'huey'+index">
                                                                {{item.titulo}} {{item.descricao}}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row justify-content-end" v-if="etapa == 1">
                                                    <div class="col text-end">
                                                        <button type="button" class="btn btn-outline-primary" @click="proximo(1)">Enviar</button>
                                                    </div>
                                                </div>
                                            </template>

                                            <!-- PROCESSANDO -->
                                            <template v-if="etapa > 1">
                                                <div class="tyn-qa-item">
                                                    <div class="tyn-qa-avatar">
                                                        <div class="tyn-qa-avatar-wrap">
                                                            <div class="tyn-media tyn-size-md" style="background: transparent">
                                                                <img src="/assets/images/sollai/avatar.png" alt="">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="tyn-qa-message tyn-text-block bg-response">
                                                        <template v-if="statusPergunta == 'Processando' || statusPergunta == 'Iniciada'">
                                                            <p class="fw-bold mb-2">
                                                                {{mensagemProcessando}}
                                                            </p>
                                                            <p class="mb-2">
                                                                Por favor, aguarde um momento enquanto eu processo a sua resposta. Obrigado pela sua paciência e compreensão.
                                                            </p>
                                                            <div class="progress px-0">
                                                                <div class="progress-bar progress-bar-striped progress-bar-animated bg-blue-2" role="progressbar" :aria-valuenow="timer" aria-valuemin="0" aria-valuemax="100" :style="{width: timer+'%'}"></div>
                                                            </div>
                                                        </template>
                                                        <template v-if="statusPergunta == 'Cancelada'">
                                                            <span class="text-danger fs-1">
                                                                <i class="fas fa-exclamation-triangle"></i>
                                                            </span>
                                                            <p class="mb-2">
                                                                Erro ao processar a pergunta
                                                            </p>
                                                            <p class="mb-2">
                                                                {{msgErro}}
                                                            </p>
                                                            <button class="btn-default bg-solid-primary" @click="enviarPergunta(false)" v-if="flReprocessar">
                                                                Reprocessar
                                                            </button>
                                                        </template>
                                                        <template v-if="statusPergunta == 'Finalizada'">
                                                            <template v-if="processoConversa">
                                                                <p class="mb-20" style="white-space: pre-line;" :id="'resposta_'+processoConversa.idProcessoConversa" v-html="processoConversa.dsResposta">
                                                                </p>
                                                            </template>
                                                        </template>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <!-- RESULTADO -->
                                        <div class="tyn-qa tyn-qa-bubbly" id="printMe" v-if="processoConversa">

                                            <div class="tyn-qa-item">
                                                <div class="tyn-qa-avatar">
                                                    <div class="tyn-media tyn-size-md">
                                                        <template v-if="user.usuarioApi">
                                                            <img v-if="user.usuarioApi.urlImgFoto" :src="user.usuarioApi.urlImgFoto" alt="" />
                                                            <img v-else src="/assets/images/avatar/3.jpg" alt="">
                                                        </template>
                                                        <template v-else>
                                                            <img src="/assets/images/avatar/3.jpg" alt="">
                                                        </template>
                                                    </div>
                                                </div>
                                                <div class="tyn-qa-message tyn-text-block bg-question">{{processoConversa.dsPergunta}}</div>
                                            </div>


                                            <div class="tyn-qa-item" v-if="processoConversa">
                                                <div class="tyn-qa-avatar">
                                                    <div class="tyn-qa-avatar-wrap">
                                                        <div class="tyn-media tyn-size-md" style="background: transparent">
                                                            <img src="/assets/images/sollai/avatar.png" alt="">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="tyn-qa-message tyn-text-block bg-response" v-if="processoConversa">
                                                    <div class="d-flex justify-content-end">
                                                        <div class="dropdown" v-if="!flImprimir">
                                                            <button class="btn btn-icon btn-light  dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                                                    <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                                                </svg>
                                                            </button>
                                                            <ul class="dropdown-menu acoes">
                                                                <li>
                                                                    <a class="dropdown-item ds-6" href="javascript:void(0)" @click="imprimir">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                                                                            <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
                                                                            <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
                                                                        </svg> Imprimir
                                                                    </a>
                                                                </li>
                                                                <li v-if="statusPergunta == 'Finalizada'">
                                                                    <a class="dropdown-item ds-6" href="javascript:void(0)" @click="pdf">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-pdf" viewBox="0 0 16 16">
                                                                            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                                                            <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" />
                                                                        </svg> Baixar PDF
                                                                    </a>
                                                                </li>
                                                                <li v-if="statusPergunta == 'Finalizada'">
                                                                    <a class="dropdown-item ds-6" href="javascript:void(0)" @click="word">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-word" viewBox="0 0 16 16">
                                                                            <path d="M5.485 6.879a.5.5 0 1 0-.97.242l1.5 6a.5.5 0 0 0 .967.01L8 9.402l1.018 3.73a.5.5 0 0 0 .967-.01l1.5-6a.5.5 0 0 0-.97-.242l-1.036 4.144-.997-3.655a.5.5 0 0 0-.964 0l-.997 3.655L5.485 6.88z" />
                                                                            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                                                        </svg> Baixar Word
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div class="row mt-2">
                                                        <div class="col-12 col-md-8">
                                                            <template v-if="statusPergunta == 'Processando' || statusPergunta == 'Iniciada'">
                                                                <p class="fw-bold mb-2">
                                                                    {{mensagemProcessando}}
                                                                </p>
                                                                <p class="mb-2">
                                                                    Por favor, aguarde um momento enquanto eu processo a sua resposta. Obrigado pela sua paciência e compreensão.
                                                                </p>
                                                                <div class="progress px-0">
                                                                    <div class="progress-bar progress-bar-striped progress-bar-animated bg-blue-2" role="progressbar" :aria-valuenow="timer" aria-valuemin="0" aria-valuemax="100" :style="{width: timer+'%'}"></div>
                                                                </div>
                                                            </template>
                                                            <template v-if="statusPergunta == 'Cancelada'">
                                                                <span class="text-danger fs-1">
                                                                    <i class="fas fa-exclamation-triangle"></i>
                                                                </span>
                                                                <p class="fw-bold mb-2">
                                                                    Erro ao processar a pergunta
                                                                </p>
                                                                <p class="mb-2">
                                                                    {{msgErro}}
                                                                </p>
                                                            </template>
                                                            <template v-if="statusPergunta == 'Finalizada'">
                                                                <template v-if="processoConversa">
                                                                    <div class="mb-2 resposta" style="white-space: pre-line; " :id="'resposta_'+processoConversa.idProcessoConversa" v-html="processoConversa.dsResposta">
                                                                    </div>
                                                                </template>
                                                            </template>
                                                        </div>
                                                        <div class="col-12 col-md-4 referencias mt-5 mt-sm-0" v-if="processoConversa">
                                                            <p class="mb-0">
                                                                <strong>Data da solicitação: </strong>{{processoConversa.dtPergunta}}
                                                            </p>
                                                            <p class="mb-2">
                                                                <strong>Formato de resposta: </strong>
                                                                <template v-if="processoConversa.tpPergunta == 'Resposta objetiva' || processoConversa.tpPergunta == 'RO'">
                                                                    Resposta Objetiva
                                                                </template>
                                                                <template v-else>
                                                                    Parecer técnico
                                                                </template>
                                                            </p>

                                                            <p class="mb-0" v-if="legislacao">
                                                                <strong>Legislação: </strong>
                                                                <template v-if="legislacao.dsNome == 'Sistema S'">
                                                                    <span> {{legislacao.dsNome}}</span>
                                                                </template>
                                                                <template v-else>
                                                                    <a href="javascript:void(0)" @click="openReferencia(legislacao.tpConteudo, legislacao.idConteudo)" v-if="!flImprimir">
                                                                        {{legislacao.dsNome}}
                                                                    </a>
                                                                    <span v-else> {{legislacao.dsNome}}</span>
                                                                </template>
                                                            </p>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- mensagens -->
                                            <div class="tyn-qa tyn-qa-bubbly" v-for="(item,index) in processoConversa.lstProcessoConversa" :key="index">
                                                <div class="tyn-qa-item">
                                                    <div class="tyn-qa-avatar">
                                                        <div class="tyn-media tyn-size-md">
                                                            <template v-if="item.solicitante">
                                                                <img v-if="item.solicitante.urlImgFoto" :src="item.solicitante.urlImgFoto" alt="" />
                                                                <img v-else src="/assets/images/avatar/3.jpg" alt="">
                                                            </template>
                                                            <template v-else>
                                                                <img src="/assets/images/avatar/3.jpg" alt="">
                                                            </template>
                                                        </div>
                                                    </div>
                                                    <div class="tyn-qa-message tyn-text-block bg-question">{{item.dsPergunta}}</div>
                                                </div>

                                                <div class="tyn-qa-item">
                                                    <div class="tyn-qa-avatar">
                                                        <div class="tyn-qa-avatar-wrap">
                                                            <div class="tyn-media tyn-size-md" style="background: transparent">
                                                                <img src="/assets/images/sollai/avatar.png" alt="">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="tyn-qa-message tyn-text-block bg-response" v-if="processoConversa">
                                                        <div class="d-flex justify-content-end">
                                                            <div class="dropdown" v-if="!flImprimir">
                                                                <button class="btn btn-icon btn-light  dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-three-dots-vertical" viewBox="0 0 16 16">
                                                                        <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" />
                                                                    </svg>
                                                                </button>
                                                                <ul class="dropdown-menu acoes">
                                                                    <li>
                                                                        <a class="dropdown-item ds-6" href="javascript:void(0)" @click="imprimir">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                                                                                <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />
                                                                                <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1" />
                                                                            </svg> Imprimir
                                                                        </a>
                                                                    </li>
                                                                    <li v-if="item.status == 'Finalizada'">
                                                                        <a class="dropdown-item ds-6" href="javascript:void(0)" @click="pdf">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-pdf" viewBox="0 0 16 16">
                                                                                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                                                                <path d="M4.603 14.087a.8.8 0 0 1-.438-.42c-.195-.388-.13-.776.08-1.102.198-.307.526-.568.897-.787a7.7 7.7 0 0 1 1.482-.645 20 20 0 0 0 1.062-2.227 7.3 7.3 0 0 1-.43-1.295c-.086-.4-.119-.796-.046-1.136.075-.354.274-.672.65-.823.192-.077.4-.12.602-.077a.7.7 0 0 1 .477.365c.088.164.12.356.127.538.007.188-.012.396-.047.614-.084.51-.27 1.134-.52 1.794a11 11 0 0 0 .98 1.686 5.8 5.8 0 0 1 1.334.05c.364.066.734.195.96.465.12.144.193.32.2.518.007.192-.047.382-.138.563a1.04 1.04 0 0 1-.354.416.86.86 0 0 1-.51.138c-.331-.014-.654-.196-.933-.417a5.7 5.7 0 0 1-.911-.95 11.7 11.7 0 0 0-1.997.406 11.3 11.3 0 0 1-1.02 1.51c-.292.35-.609.656-.927.787a.8.8 0 0 1-.58.029m1.379-1.901q-.25.115-.459.238c-.328.194-.541.383-.647.547-.094.145-.096.25-.04.361q.016.032.026.044l.035-.012c.137-.056.355-.235.635-.572a8 8 0 0 0 .45-.606m1.64-1.33a13 13 0 0 1 1.01-.193 12 12 0 0 1-.51-.858 21 21 0 0 1-.5 1.05zm2.446.45q.226.245.435.41c.24.19.407.253.498.256a.1.1 0 0 0 .07-.015.3.3 0 0 0 .094-.125.44.44 0 0 0 .059-.2.1.1 0 0 0-.026-.063c-.052-.062-.2-.152-.518-.209a4 4 0 0 0-.612-.053zM8.078 7.8a7 7 0 0 0 .2-.828q.046-.282.038-.465a.6.6 0 0 0-.032-.198.5.5 0 0 0-.145.04c-.087.035-.158.106-.196.283-.04.192-.03.469.046.822q.036.167.09.346z" />
                                                                            </svg> Baixar PDF
                                                                        </a>
                                                                    </li>
                                                                    <li v-if="item.status == 'Finalizada'">
                                                                        <a class="dropdown-item ds-6" href="javascript:void(0)" @click="word">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-word" viewBox="0 0 16 16">
                                                                                <path d="M5.485 6.879a.5.5 0 1 0-.97.242l1.5 6a.5.5 0 0 0 .967.01L8 9.402l1.018 3.73a.5.5 0 0 0 .967-.01l1.5-6a.5.5 0 0 0-.97-.242l-1.036 4.144-.997-3.655a.5.5 0 0 0-.964 0l-.997 3.655L5.485 6.88z" />
                                                                                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                                                            </svg> Baixar Word
                                                                        </a>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                        <div class="row mt-2">
                                                            <div class="col-12 col-md-8">
                                                                <template v-if="item.status == 'Processando' || item.status == 'Iniciada'">
                                                                    <p class="fw-bold mb-2">
                                                                        {{mensagemProcessando}}
                                                                    </p>
                                                                    <p class="mb-2">
                                                                        Por favor, aguarde um momento enquanto eu processo a sua resposta. Obrigado pela sua paciência e compreensão.
                                                                    </p>
                                                                    <div class="progress px-0">
                                                                        <div class="progress-bar progress-bar-striped progress-bar-animated bg-blue-2" role="progressbar" :aria-valuenow="timer" aria-valuemin="0" aria-valuemax="100" :style="{width: timer+'%'}"></div>
                                                                    </div>
                                                                </template>
                                                                <template v-if="item.status == 'Cancelada'">
                                                                    <span class="text-danger fs-1">
                                                                        <i class="fas fa-exclamation-triangle"></i>
                                                                    </span>
                                                                    <p class="fw-bold mb-2">
                                                                        Erro ao processar a pergunta
                                                                    </p>
                                                                    <p class="mb-2">
                                                                        {{msgErro}}
                                                                    </p>
                                                                </template>
                                                                <template v-if="item.status == 'Finalizada'">
                                                                    <div class="mb-2 resposta" style="white-space: pre-line; " :id="'resposta_'+item.idProcessoConversa" v-html="item.dsResposta">
                                                                    </div>
                                                                </template>
                                                            </div>
                                                            <div class="col-12 col-md-4 referencias mt-5 mt-sm-0" v-if="item">
                                                                <p class="mb-0">
                                                                    <strong>Data da solicitação: </strong>{{item.dtPergunta}}
                                                                </p>
                                                                <p class="mb-2">
                                                                    <strong>Formato de resposta: </strong>
                                                                    <template v-if="item.tpPergunta == 'Resposta objetiva' || item.tpPergunta == 'RO'">
                                                                        Resposta Objetiva
                                                                    </template>
                                                                    <template v-else>
                                                                        Parecer técnico
                                                                    </template>
                                                                </p>

                                                                <p class="mb-0" v-if="legislacao">
                                                                    <strong>Legislação: </strong>
                                                                    <template v-if="legislacao.dsNome == 'Sistema S'">
                                                                        <span> {{legislacao.dsNome}}</span>
                                                                    </template>
                                                                    <template v-else>
                                                                        <a href="javascript:void(0)" @click="openReferencia(legislacao.tpConteudo, legislacao.idConteudo)" v-if="!flImprimir">
                                                                            {{legislacao.dsNome}}
                                                                        </a>
                                                                        <span v-else> {{legislacao.dsNome}}</span>
                                                                    </template>
                                                                </p>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- NOVA SUBMENSAGEM -->
                                            <div class="tyn-qa-item" v-if="flRealizaPergunta && verificaPermissao('PE')">
                                                <div class="tyn-qa-avatar">
                                                    <div class="tyn-media tyn-size-md">
                                                        <template v-if="user.usuarioApi">
                                                            <img v-if="user.usuarioApi.urlImgFoto" :src="user.usuarioApi.urlImgFoto" alt="" />
                                                            <img v-else src="/assets/images/avatar/3.jpg" alt="">
                                                        </template>
                                                        <template v-else>
                                                            <img src="/assets/images/avatar/3.jpg" alt="">
                                                        </template>
                                                    </div>
                                                </div>
                                                <div class="tyn-qa-message tyn-text-block bg-question">
                                                    <div class="form-group-modern w-100">
                                                        <textarea class="form-control-modern"
                                                                  rows="3"
                                                                  id="tynBotInput"
                                                                  v-model="formPergunta.dsPergunta"
                                                                  placeholder="Digite sua pergunta aqui..."
                                                                  maxlength="5000"></textarea>
                                                        <div class="char-counter" v-if="formPergunta.dsPergunta">
                                                            {{ formPergunta.dsPergunta.length }}/5000
                                                        </div>
                                                    </div>
                                                    <div class="row justify-content-end mt-3">
                                                        <div class="col text-end">
                                                            <button type="button"
                                                                    class="btn btn-outline-primary"
                                                                    @click="enviarPergunta(true)"
                                                                    :disabled="!formPergunta.dsPergunta || formPergunta.dsPergunta.length < 3">
                                                                Enviar Pergunta
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </template>
                                </div>
                            </div>
                            <div class="tyn-chat-form border-0 px-4" v-if="flInputText && idProcessoConversa == 0 && verificaPermissao('PE')">
                                <div class="container px-0">
                                    <div class="chat-input-modern">
                                        <div class="chat-input-wrapper">
                                            <div class="form-group-modern w-100">
                                                <textarea class="form-control-modern"
                                                          rows="3"
                                                          id="tynBotInput"
                                                          v-model="formPergunta.dsPergunta"
                                                          placeholder="Digite sua pergunta aqui..."
                                                          maxlength="5000"></textarea>
                                                <div class="char-counter" v-if="formPergunta.dsPergunta">
                                                    {{ formPergunta.dsPergunta.length }}/5000
                                                </div>
                                            </div>
                                            <button id="tynBotSend"
                                                    type="button"
                                                    @click="proximo(0)"
                                                    class="btn-send-modern"
                                                    :disabled="!formPergunta.dsPergunta || formPergunta.dsPergunta.length < 3">
                                                <i class="fas fa-paper-plane me-2"></i>
                                                <span>Enviar Pergunta</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
            </template>

            <template v-else-if="flProcesso">
                <div class="tyn-content tyn-content-page">
                    <div class="tyn-main">
                        <div class="tyn-section tyn-section-lg">
                            <div class="container">
                                <div class="tyn-section-head tyn-text-block text-center">
                                    <h2 class="h1">Ops!</h2>
                                    <p>Processo não encontrado.</p>
                                    <button class="btn btn-primary" @click="voltar"><i class="fas fa-arrow-left"></i> Voltar </button>
                                </div><!-- .tyn-section-head -->
                            </div><!-- .container -->
                        </div><!-- .tyn-section -->
                    </div><!-- .tyn-main -->
                </div>
            </template>
        </template>
        <Modais />
        <ModalTrocaNome :showModal="showModalTrocaNome" :idProcesso="id.toString()" :dsNome="processo?.dsNome" :dsProcesso="processo?.dsProcesso" :dsObjeto="processo?.dsObjeto" :cdProcesso="processo?.cdProcesso" @close="showModalTrocaNome = false" @nome-alterado="onNomeAlterado" />
        <ModalProcessoNorma :showModal="showModalProcessoNorma" :idProcesso="id.toString()" @close="showModalProcessoNorma = false" :modoVisualizacao="modoVisualizacao" />
        <ModalProcessoArtefato :flPermissao="verificaPermissao('UP')" :flProprietario="flProprietario" :idProcessoModeloArtefato="idProcessoModeloArtefato.toString()" :idProcesso="id.toString()" :dsNome="processo?.dsNome.toString()" :nrOrdem="artefatoSelecionado?.nrOrdem" :idLegislacao="processoLegislacao?.idLegislacao" :cdLegislacao="processoLegislacao?.cdLegislacao" :showModal="showModalProcessoArtefato" :flPrazo="flPrazoModal" :dependencias="dependenciasModal" :bloqueado="bloqueadoModal" :etapaFluxo="etapaFluxoModal" :temAlgumaEtapa="temAlgumaEtapaModal" :flTemWorkflow="flTemWorkflow" :dsLoginProprietario="processo?.dsLogin" @atualizar="load" :modoVisualizacao="modoVisualizacao || artefatoSelecionado?.flInativoWorkflow === true" />
        <ModalItem :showModal="showModalItem" :idProcesso="id.toString()" @close="showModalItem = false" :modoVisualizacao="modoVisualizacao" />
        <ModalProcessoPermissao :idProcesso="id.toString()" :nomeProcesso="processo?.dsNome.toString()" :showModal="showModalProcessoPermissao" @atualizar="load" />
        <ModalDadosRegistroNecessidade :dsNome="processo?.dsNome.toString()" :showModal="showModalRegistroNecessidade" :lstDados="dadosRegistroNecessidade" />
        <div class="modal fade modern-modal modal-itens-setor" id="ModalItensPorSetor" tabindex="-1" data-bs-focus="false">
            <div class="modal-dialog modal-dialog-centered  modal-xl modal-modern modal-itens-setor-dialog">
                <div class="modal-content modal-modern-content border-0">

                    <button type="button"
                            class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3 btn-close-modern"
                            data-bs-dismiss="modal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                                <polyline points="9 22 9 12 15 12 15 22" />
                            </svg>
                        </div>
                        <div class="header-text">
                            <h2>Detalhes por setor</h2>
                            <p v-if="detalheItemSelecionado">
                                {{ detalheItemSelecionado.nmItem || ('Item ' + detalheItemSelecionado.idItem) }}
                            </p>
                            <p v-else class="text-muted">Selecione um item para ver os detalhes.</p>
                        </div>
                    </div>

                    <div class="modal-modern-body">
                        <template v-if="!detalheItemSelecionado">
                            <div class="modal-itens-setor-empty">
                                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16" class="empty-icon">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                    <path d="M8.93 6.588l-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533z" />
                                    <circle cx="8" cy="4.5" r="1" />
                                </svg>
                                <h3>Nenhum item selecionado</h3>
                                <p>Clique em "Detalhes" em um item da tabela para visualizar as quantidades por setor.</p>
                            </div>
                        </template>

                        <template v-else>
                            <div class="modal-itens-setor-info mb-3">
                                <div class="info-reference">
                                    {{ detalheItemSelecionado.cdReferencia || detalheItemSelecionado.cdItem || '-' }}
                                    <span v-if="detalheItemSelecionado.tpItem"> • {{ detalheItemSelecionado.tpItem }}</span>
                                </div>
                                <div class="info-total-chip">
                                    Total: <b>{{ formatQtd(detalheItemSelecionado.qtdTotalItem) }}</b>
                                </div>
                            </div>

                            <div class="table-wrapper modern-table modal-itens-setor-table">
                                <table class="custom-table">
                                    <thead>
                                        <tr>
                                            <th>Setor</th>
                                            <th class="text-end" style="width: 150px;">Quantidade Solicitada</th>
                                            <th class="text-center" style="width:10%"></th>
                                            <th class="text-end" style="width: 150px;">Quantidade Utilizada</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(s, idx) in (detalheItemSelecionado.porSetor || [])"
                                            :key="(s.idSetor || 0) + '-' + idx">
                                            <td>{{ s.nmSetor || ('Setor ' + s.idSetor) }}</td>
                                            <td class="text-end">
                                                <span class="number-badge">{{ formatQtd(s.qtd) }}</span>
                                            </td>
                                            <td class="text-center">
                                                <button type="button"
                                                        class="modern-btn modern-btn-secondary"
                                                        @click="s.qtdUtilizada = s.qtd"
                                                        title="Utilizar Total Requisitado">
                                                    <i class="fas fa-arrow-right"></i>
                                                </button>
                                            </td>
                                            <td>
                                                <input type="number"
                                                       class="lock-registro-input form-control form-control-sm text-end"
                                                       v-model.number="s.qtdUtilizada"
                                                       :min="0"
                                                       step="any"
                                                       placeholder="0" />
                                            </td>
                                        </tr>

                                        <tr v-if="!(detalheItemSelecionado.porSetor || []).length">
                                            <td colspan="4" class="empty-state">
                                                <div class="empty-content">
                                                    <h3 class="empty-title">Sem solicitações por setor</h3>
                                                    <p class="empty-description">Nenhuma quantidade distribuída por setor para este item.</p>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </template>
                    </div>

                    <div class="modal-modern-footer mt-auto">
                        <div class="d-flex gap-2">
                            <button type="button" data-bs-dismiss="modal" class="modern-btn modern-btn-secondary flex-fill"> 
                                Cancelar 
                            </button>
                            <button type="button" class="modern-btn modern-btn-primary flex-fill bg-light" @click="salvarQuantidadesDetalhes">
                                Salvar 
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="tooltipNumeroProcesso.visible"
             class="tooltip-numero-processo"
             :style="tooltipNumeroProcesso.style">
            {{ tooltipNumeroProcesso.text }}
        </div>
    </div> <!-- tyn-root -->
</template>

<script>
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import ModalProcessoArtefato from '@/components/ModalProcessoArtefato'
    import ModalProcessoPermissao from '@/components/ProcessoInteligente/ModalProcessoPermissao'
    import ModalTrocaNome from '@/components/ProcessoInteligente/ModalTrocaNome.vue'
    import ModalProcessoNorma from '@/components/ModalProcessoNorma'
    import ModalDadosRegistroNecessidade from '@/components/ProcessoInteligente/ModalDadosRegistroNecessidade.vue'
    import Historico from '@/components/HistoricoProcessoConversa'
    import CardArtefato from "@/components/CardArtefato.vue"
    import ModalItem from '@/components/ModalItem.vue'
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'
    import Swal from 'sweetalert2'

    export default {
        name: 'DetalhesProcesso',
        components: { Header, Modais, ModalProcessoArtefato, ModalTrocaNome, Historico, CardArtefato, ModalProcessoNorma, ModalItem, ModalProcessoPermissao, ModalDadosRegistroNecessidade },
        props: ['id'],
        computed: {
            user() {
                return this.$store.state.user
            },
            isAdmContrato() {
                return this.$store.state.isAdmContrato
            },
            isAdmin() {
                return this.$store.state.isAdmin === 'Sim';
            },
            podeGerenciarProcessos() {
                return this.isAdmContrato == 'Sim' || this.isAdmin;
            },
            hubConection() {
                return this.$store.state.hubConection
            },
            lstNormas() {
                return this.$store.state.lstNormas
            },
            indexAtual() {
                return this.artefatosOrdenados.findIndex(x =>
                    !x.flInativoWorkflow && !x.flArtefatoFinalizado
                );
            },
            isMobile() {
                return window.innerWidth < 1400;
            },
            reloadGlobal() {
                return this.$store.state.reload;
            },
            checagensProntas() {
                return this.flVerificouUtilizacoes && this.flVerificouRealizar;
            },
            podePerguntar() {
                return !!(this.utilizacoes?.permiteRealizarConversa && this.flRealizaPergunta);
            },
            flPrazoModal() {
                const selecionado = Number(this.idProcessoModeloArtefato);
                const list = Array.isArray(this.workflowConfig) ? this.workflowConfig : [];
                const wf = list.find(w =>
                    w.idProcessoModeloArtefato === selecionado ||
                    w.idModeloArtefato === selecionado
                );
                return !!(wf && wf.flAtivo !== false && wf.flPrazo);
            },
            dependenciasModal() {
                const pend = this.dependenciasPendentesNomesByModelId(this.idProcessoModeloArtefato);
                return pend.length ? pend : this.dependenciasNomesByModelId(this.idProcessoModeloArtefato);
            },
            bloqueadoModal() {
                return this.isBloqueado(this.idProcessoModeloArtefato);
            },

            etapaFluxoModal() {
                const selecionado = Number(this.idProcessoModeloArtefato);
                const list = Array.isArray(this.workflowConfig) ? this.workflowConfig : [];
                const wf = list.find(w =>
                    w.idProcessoModeloArtefato === selecionado ||
                    w.idModeloArtefato === selecionado
                );
                if (!wf || wf.flAtivo === false) return null;

                // ordem de prioridade
                if (wf.flRevisao) return 'revisao';
                if (wf.flAprovacao) return 'aprovacao';
                if (wf.flAssinatura) return 'assinatura';
                return null;
            },

            temAlgumaEtapaModal() {
                return this.etapaFluxoModal !== null;
            },
            artefatoSelecionado() {
                const id = Number(this.idProcessoModeloArtefato);
                return this.lstProcessoArtefato.find(a => a.idProcessoModeloArtefato === id) || null;
            },
            flTemWorkflow() {
                const hasWfId =
                    Array.isArray(this.processoWorkflow) &&
                    this.processoWorkflow[0]?.idProcessoWorkflow > 0;

                const hasCfg =
                    Array.isArray(this.workflowConfig) &&
                    this.workflowConfig.length > 0;

                return !!(hasWfId && hasCfg);
            },

            // Configuração do fluxo indexada por modelo. Fica vazio quando o processo
            // não tem workflow, e nesse caso nada é reordenado nem escondido.
            configWorkflowPorModeloId() {
                const mapa = {};
                if (!this.flTemWorkflow) return mapa;

                this.workflowConfig.forEach(cfg => {
                    const idModelo = Number(cfg?.idProcessoModeloArtefato ?? cfg?.idModeloArtefato);
                    if (!idModelo || mapa[idModelo]) return;
                    mapa[idModelo] = cfg;
                });

                return mapa;
            },

            // Ordem definida no fluxo, por modelo. Fica vazio quando nenhuma
            // configuração tem nrOrdem preenchido.
            ordemWorkflowPorModeloId() {
                const mapa = {};

                Object.keys(this.configWorkflowPorModeloId).forEach(idModelo => {
                    const bruto = this.configWorkflowPorModeloId[idModelo]?.nrOrdem;
                    if (bruto == null) return;

                    const ordem = Number(bruto);
                    if (Number.isFinite(ordem)) mapa[idModelo] = ordem;
                });

                return mapa;
            },

            artefatosOrdenados() {
                const lista = Array.isArray(this.lstProcessoArtefato) ? this.lstProcessoArtefato : [];
                const configs = this.configWorkflowPorModeloId;

                const visiveis = lista.filter(item => {
                    const configuracao = configs[item.idProcessoModeloArtefato];
                    const possuiUpload = item.qtdEnviado > 0 || item.flEnviado === true;
                    // Modelo nativo vem com idCliente nulo; qualquer valor preenchido
                    // indica inclusão pelo workflow, inclusive o cliente 0 (admin).
                    const adicionadoPeloCliente = item.idCliente != null;
                    const idClienteProcesso = this.processo?.idCliente;
                    const mesmoCliente = idClienteProcesso != null &&
                        item.idCliente != null &&
                        Number(item.idCliente) === Number(idClienteProcesso);
                    const idWorkflowProcesso = Number(this.processo?.idProcessoWorkflow);
                    const doWorkflowDoProcesso = item.idProcessoWorkflow == null ||
                        Number(item.idProcessoWorkflow) === idWorkflowProcesso;

                    if (adicionadoPeloCliente) {
                        return this.flTemWorkflow &&
                            mesmoCliente &&
                            doWorkflowDoProcesso &&
                            !!configuracao &&
                            (configuracao.flAtivo !== false || possuiUpload);
                    }

                    return !configuracao ||
                        configuracao.flAtivo !== false ||
                        possuiUpload;
                });

                const ordemPorModelo = this.ordemWorkflowPorModeloId;
                if (!Object.keys(ordemPorModelo).length) return visiveis;

                return visiveis
                    .map((item, posicaoOriginal) => ({ item, posicaoOriginal }))
                    .sort((a, b) => {
                        const ordemA = ordemPorModelo[a.item.idProcessoModeloArtefato];
                        const ordemB = ordemPorModelo[b.item.idProcessoModeloArtefato];
                        // Artefato sem ordem no fluxo vai para o fim mantendo a posição relativa.
                        if (ordemA == null && ordemB == null) return a.posicaoOriginal - b.posicaoOriginal;
                        if (ordemA == null) return 1;
                        if (ordemB == null) return -1;
                        if (ordemA !== ordemB) return ordemA - ordemB;
                        return a.posicaoOriginal - b.posicaoOriginal;
                    })
                    .map(entrada => entrada.item);
            },
            deveBloquearPorRegistro() {
                const aguardando = this.processo?.flAguardando === true;
                if (!aguardando) return false;

                if (!this.flVerificouRegistroSolic) return false;

                const hasRows = Array.isArray(this.registroSolicRows) && this.registroSolicRows.length > 0;

                const id = Number(this.idRegistroNecessidade || 0);
                const pendente = id === 0;

                return hasRows && pendente;
            },

            showLockRegistro() {
                return this.deveBloquearPorRegistro;
            },
            registroLoteUnico() {
                // Só faz sentido no lock; fora dele assume lote único (não mostra coluna)
                if (!this.showLockRegistro) return true;

                const lotes = Array.isArray(this.registroLotes) ? this.registroLotes : [];
                return lotes.length <= 1;
            },

            registroPodeIniciar() {
                const dataLimite = new Date(this.processo.dtLimiteRegistroNecessidade);
                const hoje = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());
                if (dataLimite >= hoje) {
                    return false;
                }

                const itens = Array.isArray(this.registroItens) ? this.registroItens : [];
                if (!itens.length) return false;
                const isLoteUnico = this.isLoteUnico === true;
                const lotes = Array.isArray(this.registroLotes) ? this.registroLotes : [];
                const loteIds = lotes.map(x => Number(x.idProcessoItemLote)).filter(n => n > 0);

                let temAlgumMaiorQueZero = false;

                for (const it of itens) {
                    const qtd = Number(it.qtdIniciar);

                    if (!Number.isFinite(qtd)) return false;
                    if (qtd < 0 ) return false;

                    if (qtd > 0 || qtd == 0) {
                        temAlgumMaiorQueZero = true;

                        const um = Number(it.idUnidadeMedida);
                        if (!Number.isFinite(um) || um <= 0) return false;

                        if (!isLoteUnico) {
                            const loteId = Number(it.idProcessoItemLoteSelecionado);
                            if (!Number.isFinite(loteId) || loteId <= 0) return false;
                            if (loteIds.length && !loteIds.includes(loteId)) return false;
                        }
                    }
                }

                return temAlgumMaiorQueZero;
            },
        },
        data: function () {
            return {
                flProcesso: false,
                processo: null,
                processoLegislacao: null,
                processoTipoProcesso: null,
                historico: [],
                lstProcessoArtefato: [],
                lstUsuariosResponsavel: [],
                flInputText: true,
                idProcessoConversa: 0,
                etapa: 0,
                lstLeis: [],
                lstTiposPerguntas: [],
                utilizacoes: null,
                flVerificouUtilizacoes: false,
                formPergunta: {
                    dsPergunta: null,
                    tpPergunta: null,
                    idProcessoConversaReferencia: null,
                },
                processoConversa: null,
                legislacao: null,
                statusPergunta: null,
                timer: 0,
                intervalTimer: null,
                msgErro: null,
                disabled: false,
                flRealizaPergunta: false,
                msgNaoRealizaPergunta: "Aguarde a conclusão da pergunta atual antes de realizar uma nova pergunta",
                mensagemProcessando: "Processando pergunta...",
                flImprimir: false,
                flWord: false,
                flReprocessar: false,
                reload: false,
                debounceAtualizarScrollSetas: null,
                podeScrollEsquerda: false,
                podeScrollDireita: false,
                scrollAnimando: false,
                flVerificouRealizar: false,
                modoVisualizacao: false,
                showModalProcessoArtefato: false,
                idProcessoModeloArtefato: 0,
                showModalTrocaNome: false,
                novoNomeProcesso: '',
                gerandoPdf: false,
                flVerificacaoCadastroArtefato: false,
                showModalProcessoNorma: false,
                showModalItem: false,
                showModalProcessoPermissao: false,
                flProprietario: false,
                lstPermissoesProcesso: [{ cdTipoPermissao: 'VS' }, { cdTipoPermissao: 'UP' }, { cdTipoPermissao: 'PE' }, { cdTipoPermissao: 'IT' }],
                processoWorkflow: {},
                workflowConfig: [],
                dependenciasByCfgId: {},
                loadingDeps: false,
                appbarNavHeight: 180, // valor inicial, será recalculado dinamicamente
                navResizeObs: null,
                calcDebounceTimer: null,
                //trava registro de necessidade
                registroSolicRows: [],
                idRegistroNecessidade: null,
                flVerificouRegistroSolic: false,
                // lock por registro
                registroItensLoading: false,
                registroItens: [],
                detalheItemSelecionado: null,
                bsModalItensPorSetor: null,
                registroIniciando: false,
                registroLotes: [],
                isLoteUnico: true,
                dtLimiteRegistroNecessidade: null,
                loteSelecionado: 1,

                temRegistroNecessidade: false,
                showModalRegistroNecessidade: false,
                dadosRegistroNecessidade: [],
                tooltipNumeroProcesso: {
                    visible: false,
                    text: '',
                    style: {},
                },
            }
        },

        methods: {
            voltar() {
                this.$router.go(-1)
            },

            mostrarTooltipNumeroProcesso(event) {
                const texto = this.processo?.cdProcesso || '-';
                const rect = event.currentTarget.getBoundingClientRect();
                const maxWidth = Math.min(420, window.innerWidth - 16);
                let left = rect.left;
                if (left + maxWidth > window.innerWidth - 8) {
                    left = Math.max(8, window.innerWidth - maxWidth - 8);
                }
                this.tooltipNumeroProcesso = {
                    visible: true,
                    text: texto,
                    style: {
                        top: `${rect.bottom + 8}px`,
                        left: `${left}px`,
                        maxWidth: `${maxWidth}px`,
                    },
                };
            },

            ocultarTooltipNumeroProcesso() {
                this.tooltipNumeroProcesso.visible = false;
            },

            getProcesso() {
                let $this = this;

                const id = this.$route.params.id
                axios.get(`${urlApi}/Processo/Get/${id}`)
                    .then(res => {
                        $this.flProcesso = true;
                        if (res.data.success) {
                            $this.processo = res.data.data.processo;
                            $this.processoLegislacao = res.data.data.legislacao;
                            $this.processoTipoProcesso = res.data.data.tipoProcesso;

                            if ($this.processo != null) {
                                $this.getPermissoesProcesso();
                                const deveLock = $this.processo?.flAguardando === true;
                                $this.flVerificouRegistroSolic = true;
                                $this.registroSolicRows = deveLock ? [{}] : [];
                                $this.idRegistroNecessidade = deveLock ? 0 : 1;

                                if ($this.processo.dtLimiteRegistroNecessidade) {
                                    $this.dtLimiteRegistroNecessidade = $this.processo.dtLimiteRegistroNecessidade.split('T')[0];
                                }
                                

                                if (deveLock) {
                                    $this.flInputText = false;
                                    $this.disabled = true;
                                    $this.flRealizaPergunta = false;
                                    $this.VerificaLoteUnico()
                                        .then(() => $this.carregarLotesProcessoItemLote())
                                        .then(() => $this.carregarItensRegistroPorProcesso());

                                } else {
                                    $this.flInputText = $this.idProcessoConversa == 0;
                                    $this.disabled = false;
                                }

                                $this.carregarWorkflowDoProcesso()
                                    .then(() => $this.getModelosProcesso())
                                    .catch(() => $this.getModelosProcesso());
                            }

                            if ($this.processo.flFinalizado) {
                                $this.modoVisualizacao = true;
                            }

                        } else {
                            avisoErro(res.data.msg || 'Erro ao carregar processo.')
                        }
                    })
                    .catch(err => {
                        $this.flProcesso = true;
                        if (err.response && err.response.data) {
                            avisoErro(err.response.data);
                            avisoToast("Erro ao carregar processo!", "warning");
                        } else {
                            avisoErro(err.message || "Erro desconhecido");
                        }
                    });
            },

            finalizarProcesso() {
                let $this = this;
                Swal.fire({
                    title: 'Deseja finalizar este processo?',
                    html: `<p class="mb-1">Ao finalizar, este processo será <strong>definitivamente encerrado</strong> e as seguintes ações serão bloqueadas:</p>
                                <ul class="text-center">
                                    <li style="list-style-type: disc; margin-left: 20px;">Não será possível editar os itens do processo;</li>
                                    <li style="list-style-type: disc; margin-left: 20px;">Não será permitido realizar upload ou alteração de artefatos;</li>
                                    
                                </ul>
                           <p class="mt-2">Após a finalização, o processo ficará disponível apenas para <strong>visualização e download</strong>.</p>`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Sim, finalizar processo',
                    cancelButtonText: 'Cancelar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(`${urlApi}/Processo/Finalizar`, { idProcesso: $this.id })
                            .then(res => {
                                if (res.data.success) {
                                    avisoToast("Processo finalizado com sucesso.");
                                    $this.modoVisualizacao = true;
                                } else {
                                    avisoErro("Não foi possível finalizar o processo.");
                                }
                            })
                            .catch(() => {
                                avisoErro("Erro na requisição de finalização do processo.");
                            });
                    }
                });
            },

            aplicarTravaRegistro() {
                if (!this.deveBloquearPorRegistro) return;

                this.flInputText = false;
                this.disabled = true;
                this.flRealizaPergunta = false;
            },

            onNomeAlterado() {
                this.getProcesso();
            },

            exibeModalProcessoArtefato(idProcessoModeloArtefato) {
                this.idProcessoModeloArtefato = idProcessoModeloArtefato;
                this.showModalProcessoArtefato = !this.showModalProcessoArtefato;
            },

            abrirModalEditarNome() {

                this.showModalTrocaNome = !this.showModalTrocaNome;
            },

            abrirModalItem() {
                this.showModalItem = !this.showModalItem;
            },

            abrirModalProcessoNorma() {
                this.showModalProcessoNorma = !this.showModalProcessoNorma;
            },

            async getModelosProcesso() {
                let $this = this;
                try {
                    const res = await axios.get(`${urlApi}/ProcessoArtefato/GetModelosProcesso`, {
                        showLoading: true,
                        params: { idProcesso: $this.id }
                    });

                    if (!res.data.success) {
                        avisoErro(res.data.msg || 'Erro ao carregar processo.');
                        return;
                    }

                    const result = res.data.data || [];

                    $this.lstProcessoArtefato = result.map(item => {
                        const usaWorkflow = Array.isArray($this.workflowConfig) && $this.processoWorkflow[0]?.idProcessoWorkflow > 0;

                        const flArtefatoFinalizado = usaWorkflow
                            ? item.nmStatusAtual === "Finalizado"
                            : item.qtdEnviado > 0;

                        return {
                            nmModelo: $this.abreviarNome(item.nmModelo),
                            flEnviado: item.qtdEnviado > 0,
                            flRetificado: item.qtdRetificado > 0,
                            flArtefatoFinalizado,
                            idProcessoModeloArtefato: item.idProcessoModeloArtefato,
                            icone: item.nmIcone,
                            idCliente: item.idCliente,
                            idProcessoWorkflow: item.idProcessoWorkflow,
                            qtdEnviado: item.qtdEnviado || 0,
                            flInativoWorkflow:
                                usaWorkflow &&
                                $this.configWorkflowPorModeloId[item.idProcessoModeloArtefato]?.flAtivo === false,
                            nrOrdem: item.nrOrdem,
                            idProcessoArtefatoResponsavel: null,
                            responsavelLogin: "",
                            dataLimiteDate: "",
                            nmUsuario: ""
                        };
                    });

                    if ($this.lstProcessoArtefato.some(x => x.flEnviado)) {
                        $this.flVerificacaoCadastroArtefato = true;
                    }
                    this.$nextTick(() => {
                        if (this.workflowConfig?.length) {
                            this.applyDependenciesToCards();
                        }
                    });
                    const responsaveis = await Promise.all(
                        $this.lstProcessoArtefato.map(m =>
                            $this.getResponsavelPorModelo(m.idProcessoModeloArtefato)
                        )
                    );

                    await $this.getUsuariosResponsavel();
                    const idxUsuarios = new Map(($this.lstUsuariosResponsavel || []).map(u => [u.dsLogin, u.nmUsuario]));

                    responsaveis.forEach((resp, idx) => {
                        if (!resp) return;
                        const nmUsuario = idxUsuarios.get(resp.responsavelLogin) || resp.responsavelLogin;
                        Object.assign($this.lstProcessoArtefato[idx], {
                            idProcessoArtefatoResponsavel: resp.idProcessoArtefatoResponsavel,
                            responsavelLogin: resp.responsavelLogin,
                            dataLimiteDate: resp.dataLimiteDate,
                            nmUsuario
                        });
                    });

                } catch (err) {
                    avisoErro(err?.response?.data || err.message || 'Erro desconhecido');
                }
            },

            abreviarNome(nome) {
                const siglas = {
                    "Documento de Formalização de Demanda (DFD)": "DFD",
                    "Estudo Técnico Preliminar (ETP)": "ETP",
                    "Mapa de Risco": "Mapa de Risco",
                    "Termo de Referência": "Termo de Referência",
                    "Edital": "Edital",
                    "Proposta Vencedora": "Proposta Vencedora",
                };
                return siglas[nome] || nome;
            },

            fechar() {
                document.getElementById('tynMain').classList.toggle('main-shown')
            },

            novo() {
                this.idProcessoConversa = 0;
                this.etapa = 0;
                this.formPergunta = { dsPergunta: null, tpPergunta: null, idProcessoConversaReferencia: null };
                this.processoConversa = null;
                this.statusPergunta = null;
                this.timer = 0;
                this.intervalTimer = null;
                this.msgErro = null;
                this.disabled = false;
                this.flInputText = true;
                this.flReprocessar = false;

                this.load();
            },

            load() {
                this.flProcesso = false;
                this.getProcesso();

                if (this.idProcessoConversa != 0) {
                    this.disabled = true;
                    this.flInputText = false;

                    //this.carregaProcessoConversa();
                    this.carregaProcessoConversaChat();
                }

                this.verificaRealizaPergunta();
                this.carregaUtilizacoes();
                this.getRegistroNecessidade();
            },

            seleciona(id) {
                this.idProcessoConversa = id;
                this.load();
            },

            proximo(index) {
                let $this = this;
                switch (index) {
                    case 0:
                        //$this.formPergunta.dsPergunta = document.getElementById('tynBotInput').innerHTML;
                        if ($this.formPergunta.dsPergunta != '' && $this.formPergunta.dsPergunta != null && $this.formPergunta.dsPergunta.length >= 3) {
                            document.getElementById('tynBotInput').innerHTML = "";

                            $this.flInputText = false;
                            $this.etapa = 1;
                            $this.getTipoPergunta();

                        } else {
                            avisoToast("A pergunta deve conter pelo menos 3 caracteres", "warning");
                        }
                        break;
                    case 1:
                        if ($this.formPergunta.tpPergunta != null) {
                            if ($this.utilizacoes && $this.utilizacoes.permiteRealizarConversa) {
                                $this.etapa = 2;
                                $this.enviarPergunta(false);
                            } else {
                                avisoToast("Desculpe, parece que você atingiu seu limite de Perguntas do contrato. Entre em contato com um dos nossos consultores.", "warning");
                            }
                        } else {
                            avisoToast("Selecione um formato de resposta", "warning");
                        }

                        break;


                    default:
                        break;
                }
            },

            enviarPergunta(flSubConsulta) {
                let $this = this;
                if (flSubConsulta) {
                    $this.statusPergunta = 'Processando';
                    $this.disabled = true;
                    $this.iniciaProcessando();
                } else {
                    $this.statusChatSubconsulta = 'Processando';
                    $this.disabled = true;
                    $this.iniciaProcessandoSubConsulta();
                }

                axios.post(`${urlApi}/ProcessoConversa/post`, { dsPergunta: $this.formPergunta.dsPergunta, tpPergunta: $this.formPergunta.tpPergunta, idProcesso: $this.id, idProcessoConversaReferencia: $this.formPergunta.idProcessoConversaReferencia }, { showloading: false })
                    .then(res => {
                        if (res.data.success) {
                            avisoToast("Pergunta registrada com sucesso, acompanhe a situação no campo status da listagem.");

                            if (flSubConsulta) {
                                $this.reload = !$this.reload;
                                $this.idProcessoConversa = parseInt($this.processoConversa.idProcessoConversa);
                                $this.load();
                            } else {
                                $this.reload = !$this.reload;
                                $this.idProcessoConversa = parseInt(res.data.msg);
                                $this.load();
                            }
                        } else {
                            $this.flReprocessar = true;
                            avisoErro("Não foi possível enviar a pergunta.");
                        }
                    })
                    .catch(res => {
                        $this.flReprocessar = true;
                        $this.disabled = false;
                        $this.statusPergunta = 'Cancelada';
                        $this.msgErro = 'Não conseguimos responder sua pergunta';
                        if (res.response.data) {
                            if (res.response.data.msg == 'Nossa ia não identificou esse assunto relacionado com licitações e contratos') {
                                var msg = res.response.data.msg;
                                $this.msgErro = msg;
                                if (res.response.data.errors) {
                                    msg = msg + '. ' + res.response.data.errors[0];
                                }
                                avisoErro(msg);
                            } else {
                                $this.msgErro = res.response.data.msg + " - " + res.response.data.errors[0];
                                avisoErro(res.response.data.msg + " - " + res.response.data.errors[0]);

                                //avisoErro("Não foi possível enviar a pergunta.");
                            }
                        } else {
                            avisoErro("Não foi possível enviar a pergunta.");
                        }
                    });
            },

            carregaProcessoConversa() {
                let $this = this;
                axios.get(`${urlApi}/ProcessoConversa/Get/${$this.idProcessoConversa}`)
                    .then(res => {
                        $this.etapa = 4;
                        $this.processoConversa = null;
                        if (res.data.success) {
                            var result = res.data.data;

                            var status = '';
                            if (result.lstProcessoConversaMovimento.length > 0) {
                                status = result.lstProcessoConversaMovimento[result.lstProcessoConversaMovimento.length - 1].dsMovimento;
                                $this.statusPergunta = status;
                            }

                            $this.formPergunta = {
                                dsPergunta: result.conversa.dsPergunta,
                                tpPergunta: result.conversa.tpPergunta,
                            };
                            $this.processoConversa = {
                                idProcessoConversa: result.conversa.idProcessoConversa,
                                dsPergunta: result.conversa.dsPergunta,
                                dsResposta: (result.conversa.dsResposta != null ? result.conversa.dsResposta.replace(/(?:\r\n|\r|\n)/g, "<br>") : null),
                                tpPergunta: result.conversa.tpPergunta,
                                dsLogin: result.conversa.dsLogin,
                                status: status,
                                solicitante: result.solicitante,
                                dtPergunta: moment(result.conversa.dtInclusao).format('DD/MM/YYYY [às] HH:mm'),
                            };

                        } else {
                            avisoErro("Não foi possível carregar a pergunta.");
                        }

                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("erro");
                        }
                    });
            },

            carregaProcessoConversaChat() {
                let $this = this;
                axios.get(`${urlApi}/ProcessoConversa/GetChat/${$this.idProcessoConversa}`)
                    .then(res => {
                        $this.etapa = 4;
                        $this.processoConversa = null;
                        if (res.data.success) {
                            var result = res.data.data;

                            var status = '';
                            if (result.lstProcessoConversaMovimento.length > 0) {
                                status = result.lstProcessoConversaMovimento[result.lstProcessoConversaMovimento.length - 1].dsMovimento;
                                $this.statusPergunta = status;
                            }

                            $this.formPergunta = {
                                //dsPergunta: result.conversa.dsPergunta,
                                tpPergunta: result.conversa.tpPergunta,
                                idProcessoConversaReferencia: result.conversa.idProcessoConversa,
                            };
                            $this.processoConversa = {
                                idProcessoConversa: result.conversa.idProcessoConversa,
                                dsPergunta: result.conversa.dsPergunta,
                                dsResposta: (result.conversa.dsResposta != null ? result.conversa.dsResposta.replace(/(?:\r\n|\r|\n)/g, "<br>") : null),
                                tpPergunta: result.conversa.tpPergunta,
                                dsLogin: result.conversa.dsLogin,
                                status: status,
                                solicitante: result.solicitante,
                                dtPergunta: moment(result.conversa.dtInclusao).format('DD/MM/YYYY [às] HH:mm'),
                                conversaFilho: result.conversaFilho,
                                lstProcessoConversa: [],
                            };

                            var processoConversaFilho = $this.processoConversa.conversaFilho;
                            $this.contSubMensagens = 0;
                            while (processoConversaFilho != null) {
                                $this.formPergunta.idProcessoConversaReferencia = processoConversaFilho.conversa.idProcessoConversa;

                                if (processoConversaFilho.lstProcessoConversaMovimento.length > 0) {
                                    status = processoConversaFilho.lstProcessoConversaMovimento[processoConversaFilho.lstProcessoConversaMovimento.length - 1].dsMovimento;
                                    $this.statusPerguntaSubconsulta = status;
                                }

                                $this.processoConversa.lstProcessoConversa.push({
                                    idProcessoConversa: processoConversaFilho.conversa.idProcessoConversa,
                                    dsPergunta: processoConversaFilho.conversa.dsPergunta,
                                    dsResposta: (processoConversaFilho.conversa.dsResposta != null ? processoConversaFilho.conversa.dsResposta.replace(/(?:\r\n|\r|\n)/g, "<br>") : null),
                                    tpPergunta: processoConversaFilho.conversa.tpPergunta,
                                    dsLogin: processoConversaFilho.conversa.dsLogin,
                                    status: status,
                                    solicitante: processoConversaFilho.solicitante,
                                    dtPergunta: moment(processoConversaFilho.conversa.dtInclusao).format('DD/MM/YYYY [às] HH:mm'),
                                    conversaFilho: processoConversaFilho.conversaFilho,

                                    usuario: processoConversaFilho.solicitante,
                                    lstProcessoConversa: [],
                                });
                                //$this.contSubMensagens++;
                                processoConversaFilho = processoConversaFilho.conversaFilho;
                            }

                        } else {
                            avisoErro("Não foi possível carregar a pergunta.");
                        }

                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("erro");
                        }
                    });
            },

            getLegislacao(idLegislacao) {
                let $this = this;
                axios.get(`${urlApi}/Legislacao/Get/${idLegislacao}`)
                    .then(res => {
                        if (res.data.success) {
                            var result = res.data.data;
                            $this.legislacao = result;
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            iniciaProcessando: function () {
                let $this = this;
                if (this.statusPergunta == 'Processando') {
                    var flag = true;
                    $this.timer = 0;

                    if (flag) {
                        flag = false;
                        $this.intervalTimer = setInterval(function () {
                            if ($this.timer < 100) {
                                $this.timer = $this.timer + 1;
                            } else {
                                flag = true;
                                clearInterval($this.intervalTimer);
                            }
                        }, 3000);
                    }
                } else {
                    if ($this.intervalTimer && $this.intervalTimer != null) {
                        clearInterval($this.intervalTimer);
                    }
                }
            },
            iniciaProcessandoSubConsulta: function () {
                let $this = this;
                if (this.statusChatSubconsulta == 'Processando') {
                    var flag = true;
                    $this.timer = 0;

                    if (flag) {
                        flag = false;
                        $this.intervalTimer = setInterval(function () {
                            if ($this.timer < 100) {
                                $this.timer = $this.timer + 1;
                            } else {
                                flag = true;
                                clearInterval($this.intervalTimer);
                            }
                        }, 3000);
                    }
                } else {
                    if ($this.intervalTimer && $this.intervalTimer != null) {
                        clearInterval($this.intervalTimer);
                    }
                }
            },


            verificaRealizaPergunta() {
                let $this = this;
                axios.get(`${urlApi}/ProcessoConversa/VerificaRealizarPergunta`, { showLoading: false, params: { idProcesso: this.id } })
                    .then(res => {
                        if (res.data.success) {
                            $this.flRealizaPergunta = res.data.data;
                            $this.flVerificouRealizar = true;

                            $this.aplicarTravaRegistro();
                        }

                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },
            carregaUtilizacoes() {
                let $this = this;
                axios.get(`${urlApi}/ProcessoConversa/Utilizacoes`, { showLoading: false })
                    .then(res => {
                        $this.flVerificouUtilizacoes = true;
                        if (res.data.success) {
                            $this.utilizacoes = res.data.data;
                            $this.getTipoPergunta();
                        } else {
                            avisoErro("Não foi possível carregar a quantidade de perguntas.");
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.data);
                        } else {
                            avisoErro("Não foi possível carregar a quantidade de perguntas.");
                        }
                    });
            },
            getTipoPergunta() {
                let $this = this;
                axios.get(`${urlApi}/TipoPergunta/Get`, { showLoading: false, params: {} })
                    .then(res => {
                        if (res.data.success) {
                            $this.lstTiposPerguntas = [];
                            for (let i = 0; i < res.data.data.rows.length; i++) {
                                var item = res.data.data.rows[i];

                                $this.lstTiposPerguntas.push({ value: item.cdTipoPergunta, titulo: item.dsNome, descricao: item.dsTipoPergunta, });
                            }
                        }
                    })
                    .catch(res => {
                        if (res.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            InitSignalR() {
                try {
                    let $this = this;

                    //$this.hubConection.on("NovaNotificacao", function () {
                    //    $this.load();
                    //});

                    $this.hubConection.on("RecebeNotificacaoProcessoConversa", function (idProcessoConversa, status, dtAtualizacao) {
                        if ($this.idProcessoConversa == idProcessoConversa) {
                            $this.load();
                        } else {
                            let flag = false;

                            var processoConversaFilho = $this.processoConversa.conversaFilho;
                            while (processoConversaFilho != null) {
                                if (processoConversaFilho.conversa.idProcessoConversa == idProcessoConversa) {
                                    flag = true;
                                    break;
                                }
                                processoConversaFilho = processoConversaFilho.conversaFilho;
                            }

                            if (flag) {
                                $this.load();
                            } else {
                                avisoToast('Status da pergunta atualizado para ' + status + ' - ' + moment(dtAtualizacao).format('DD/MM/YYYY [às] HH:mm'));
                            }

                        }
                    });

                    $this.hubConection.on("RecebeNotificacaoProcessoArtefato", function (idProcessoArtefato, status, dtAtualizacao) {
                        avisoToast(status + ' - ' + moment(dtAtualizacao).format('DD/MM/YYYY [às] HH:mm'));
                        $this.load();
                    });


                    $this.hubConection.on("AtualizaRealizarProcessoConversa", function (flRealizaPergunta) {
                        $this.flRealizaPergunta = flRealizaPergunta == "Sim" || flRealizaPergunta == "true" ? true : false;
                    });

                    $this.hubConection.on("AtualizaStatusProcessoConversa", function (idProcessoConversa, status,) {
                        $this.mensagemProcessando = status;
                    });
                }
                catch (ex) {
                    console.log(ex);
                }
            },

            imprimir() {
                let $this = this;
                $this.flImprimir = true;
                // Pass the element id here
                $this.$nextTick(function () {
                    $this.print();
                })
            },

            async print() {
                let $this = this;
                await $this.$htmlToPaper('printMe', {
                    styles: [
                        '/assets/css/app.css',
                        '/assets/css/bundle.css',
                    ],
                }, () => {
                    $this.flImprimir = false;
                });
            },

            word() {
                let $this = this;

                axios({
                    method: 'GET',
                    url: `${urlApi}/ProcessoConversa/DownloadWord/${$this.idProcessoConversa}`,
                    responseType: 'blob',
                    showLoading: true,
                })
                    .then((response) => {
                        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = `Consulta_${$this.idProcessoConversa}.docx`;
                        link.click();
                        URL.revokeObjectURL(link.href);
                    })
                    .catch((error) => {
                        console.error("Erro ao gerar Word:", error);
                        avisoErro("Erro ao gerar Word");
                    });
            },

            pdf() {
                let $this = this;

                axios({
                    method: 'GET',
                    url: `${urlApi}/ProcessoConversa/DownloadPdf/${$this.idProcessoConversa}`,
                    responseType: 'blob',
                    showLoading: true,
                })
                    .then((response) => {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = `Consulta_${$this.idProcessoConversa}.pdf`;
                        link.click();
                        URL.revokeObjectURL(link.href);
                    })
                    .catch((error) => {
                        console.error("Erro ao gerar PDF:", error);
                        avisoErro("Erro ao gerar PDF");
                    });
            },

            baixarDocumentosZip() {
                let $this = this;

                axios({
                    method: 'GET',
                    url: `${urlApi}/ProcessoArtefato/DownloadZip/${$this.id}`,
                    responseType: 'blob',
                    showLoading: true,
                })
                    .then((response) => {
                        const blob = new Blob([response.data], { type: 'application/zip' });
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = `Processo_${$this.id}_Documentos.zip`;
                        link.click();
                        URL.revokeObjectURL(link.href);
                    })
                    .catch((error) => {
                        console.error("Erro ao baixar documentos zip:", error);
                        avisoErro("Erro ao baixar documentos");
                    });
            },

            gerarDocumentosPdf() {
                let $this = this;
                $this.gerandoPdf = true;
                axios({
                    method: 'GET',
                    url: `${urlApi}/ProcessoArtefato/GerarDoc/${$this.id}`,
                    responseType: 'blob',
                    showLoading: true,
                })
                    .then((response) => {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = `Processo_${$this.id}_Unificado.pdf`;
                        link.click();
                        URL.revokeObjectURL(link.href);
                    })
                    .catch((error) => {
                        console.error("Erro ao gerar PDF:", error);
                        avisoErro("Erro ao gerar o PDF");
                    })
                    .finally(() => {
                        $this.gerandoPdf = false;
                    });
            },

            abrirModalProcessoPermissao() {
                this.showModalProcessoPermissao = !this.showModalProcessoPermissao;
            },

            getPermissoesProcesso() {
                let $this = this;
                if ($this.processo.dsLogin != $this.user.usuario.dsLogin) {
                    if ($this.isAdmContrato != 'Sim' && !$this.isAdmin) {
                        $this.flProprietario = false;

                        axios.get(`${urlApi}/ProcessoPermissao/GetPermissoes/${$this.id}`, { showLoading: false, params: { idProcesso: $this.id } })
                            .then(res => {
                                if (res.data.success) {
                                    var lstPermissao = res.data.data.lstPermissao;
                                    var lstTipoPermissao = res.data.data.lstTipoPermissao;

                                    for (let i = 0; i < $this.lstPermissoesProcesso.length; i++) {
                                        var item = $this.lstPermissoesProcesso[i];

                                        var tipoPermissao = lstTipoPermissao.find(x => x.cdTipoPermissao == item.cdTipoPermissao);
                                        if (tipoPermissao) {
                                            if (lstPermissao.find(x => x.idTipoPermissao == tipoPermissao.idTipoPermissao)) {
                                                item.flPermissao = true;
                                            } else {
                                                item.flPermissao = false;
                                            }
                                        } else {
                                            item.flPermissao = false;
                                        }

                                    }
                                }
                            })
                            .catch(res => {
                                if (res.data != undefined) {
                                    avisoErro(res.response.data);
                                } else {
                                    avisoErro(res.response.statusText);
                                }
                            });
                    } else {
                        $this.flProprietario = true;

                        for (let i = 0; i < $this.lstPermissoesProcesso.length; i++) {
                            $this.lstPermissoesProcesso[i].flPermissao = true;
                        }
                    }

                } else {
                    $this.flProprietario = true;

                    for (let i = 0; i < $this.lstPermissoesProcesso.length; i++) {
                        $this.lstPermissoesProcesso[i].flPermissao = true;
                    }
                }
            },

            verificaPermissao(cdTipoPermissao) {
                var permissao = this.lstPermissoesProcesso.find(x => x.cdTipoPermissao == cdTipoPermissao);
                return permissao ? permissao.flPermissao : false;
            },

            scrollEsquerda() {
                const el = this.$refs.scrollContainer;
                if (!el) return;
                this.animateScroll(el, -200);
            },

            scrollDireita() {
                const el = this.$refs.scrollContainer;
                if (!el) return;

                const scrollRight = el.scrollWidth - el.scrollLeft - el.clientWidth;

                const minimoScroll = 20;
                const scrollValue = scrollRight < 200 ? scrollRight - 20 : 200;

                this.animateScroll(el, Math.max(scrollValue, minimoScroll));
            },

            animateScroll(element, distance) {
                if (this.scrollAnimando) return;
                this.scrollAnimando = true;

                const maxScroll = element.scrollWidth - element.clientWidth;
                const initial = element.scrollLeft;
                const target = Math.max(0, Math.min(initial + distance, maxScroll)); // clamp real

                const duration = 400;
                const startTime = performance.now();

                const step = (now) => {
                    const elapsed = now - startTime;
                    const progress = Math.min(elapsed / duration, 1);
                    const ease = 0.5 - Math.cos(progress * Math.PI) / 2;

                    const scrollValue = initial + (target - initial) * ease;
                    element.scrollLeft = scrollValue;

                    if (progress < 1) {
                        requestAnimationFrame(step);
                    } else {
                        element.scrollLeft = target;

                        this.$nextTick(() => {
                            setTimeout(() => {
                                this.scrollAnimando = false;
                                this.atualizarScrollSetas();
                            }, 50);
                        });
                    }
                };

                requestAnimationFrame(step);
            },

            atualizarScrollSetas() {
                if (this.scrollAnimando) return;
                const el = this.$refs.scrollContainer;
                if (!el) return;

                const scrollLeft = el.scrollLeft;
                const clientWidth = el.clientWidth;
                const scrollWidth = el.scrollWidth;
                const margemErro = 2;

                const posInicio = scrollLeft <= margemErro;
                const posFim = Math.abs(scrollLeft + clientWidth - scrollWidth) <= margemErro;

                this.podeScrollEsquerda = !posInicio;
                this.podeScrollDireita = !posFim;
            },

            async carregarWorkflowDoProcesso() {
                const idWf = Number(this.processo?.idProcessoWorkflow);
                if (idWf) {
                    await this.getWorkflowById(idWf);
                    await this.getWorkflowArtefatos(idWf);
                    return;
                }
            },

            async getWorkflowById(idProcessoWorkflow) {
                let $this = this;
                return axios.get(`${urlApi}/ProcessoWorkflow/GetWorkflow/${idProcessoWorkflow}`)
                    .then((res) => {
                        const wf = res?.data?.data?.processoWorkflow || null;

                        if (!res.data.success || !wf) {
                            $this.processoWorkflow = [];
                            return [];
                        }
                        $this.processoWorkflow = [wf]
                            .map(r => r?.processoWorkflow || r)
                            .filter(Boolean);

                        return $this.processoWorkflow;
                    })
                    .catch((err) => {
                        $this.processoWorkflow = [];
                        avisoToast("Erro ao carregar fluxo!", "warning");
                        throw err;
                    });
            },

            getWorkflowArtefatos(idProcessoWorkflow) {
                let $this = this;
                return axios.get(`${urlApi}/ProcessoWorkflow/GetWorkflowArtefato`, {
                    params: { idProcessoWorkflow },
                })
                    .then((res) => {
                        const rows = res.data.data.rows || [];
                        if (!res.data.success || rows.length === 0) {
                            $this.workflowConfig = [];
                            return [];
                        }
                        $this.workflowConfig = rows
                            .map(r => r?.processoWorkflowArtefato || r)
                            .filter(x => x && x.idProcessoWorkflowArtefato);

                        return $this.fetchAllDependenciasIfNeeded().then(() => {
                            $this.applyDependenciesToCards();
                            return $this.workflowConfig;
                        });
                    })
                    .catch((err) => {
                        $this.workflowConfig = [];
                        avisoToast("Erro ao carregar configurações do fluxo!", "warning");
                        throw err;
                    });
            },

            getResponsavelPorModelo(idProcessoModeloArtefato) {
                let $this = this;
                return axios.get(`${urlApi}/ProcessoArtefatoResponsavel/Get`, {
                    showLoading: false,
                    params: {
                        idProcesso: $this.id,
                        idProcessoModeloArtefato
                    }
                })
                    .then(({ data }) => {
                        if (!data?.success) return null;

                        const rows = data.data.rows || [];
                        const wrapper = rows.length ? rows[0] : null;
                        const r = wrapper?.processoArtefatoResponsavel || wrapper;

                        if (!r || !r.idProcessoArtefatoResponsavel) return null;

                        return {
                            idProcessoArtefatoResponsavel: r.idProcessoArtefatoResponsavel,
                            responsavelLogin: r.dsLogin || "",
                            dataLimiteDate: (r.dtLimite || "").substring(0, 10),
                        };
                    })
                    .catch(() => null);
            },

            async getUsuariosResponsavel() {
                let $this = this;
                try {
                    const { data } = await axios.get(`${urlApi}/ProcessoPermissao/GetUsuariosResponsavel/${$this.id}`, { showLoading: false });
                    if (data.success) {
                        const raw = data.data;
                        $this.lstUsuariosResponsavel = raw.map(x => x?.usuarioPermissao || x);
                    } else {
                        $this.lstUsuariosResponsavel = [];
                    }
                } catch (err) {
                    $this.lstUsuariosResponsavel = [];
                    avisoErro(err.response.data || err.message || 'Não foi possível carregar os usuários elegíveis a responsável.');
                }
            },

            findNomePorLogin(login) {
                if (!login) return '';
                const u = (this.lstUsuariosResponsavel || []).find(u => u.dsLogin === login);
                return u.nmUsuario || login;
            },

            getWorkflowDependencia(idProcessoWorkflowArtefato) {
                return axios.get(urlApi + '/ProcessoWorkflow/GetWorkflowDependencia', {
                    params: { idProcessoWorkflowArtefato }
                });
            },

            async fetchAllDependenciasIfNeeded() {
                this.dependenciasByCfgId = {};
                if (!Array.isArray(this.workflowConfig) || this.workflowConfig.length === 0) return;

                this.loadingDeps = true;
                try {
                    const calls = this.workflowConfig
                        .filter(cfg => cfg?.idProcessoWorkflowArtefato && cfg.flDependencia === true)
                        .map(async (cfg) => {
                            try {
                                const res = await this.getWorkflowDependencia(cfg.idProcessoWorkflowArtefato);
                                const rows = res.data.data.rows || [];
                                this.$set(this.dependenciasByCfgId, cfg.idProcessoWorkflowArtefato, rows);
                            } catch {
                                this.$set(this.dependenciasByCfgId, cfg.idProcessoWorkflowArtefato, []);
                            }
                        });
                    await Promise.all(calls);
                } finally {
                    this.loadingDeps = false;
                }
            },
            cfgByModelId(modelId) {
                const list = Array.isArray(this.workflowConfig) ? this.workflowConfig : [];
                return list.find(w =>
                    w.idProcessoModeloArtefato === Number(modelId) ||
                    w.idModeloArtefato === Number(modelId)
                ) || null;
            },

            depModelIdsByModelId(modelId) {
                const cfg = this.cfgByModelId(modelId);
                if (!cfg) return [];

                const rows = (this.dependenciasByCfgId || {})[cfg.idProcessoWorkflowArtefato] || [];

                const configs = this.configWorkflowPorModeloId;

                const ids = rows
                    .map(r =>
                        r.processoWorkflowDependencia?.idProcessoModeloArtefatoDependencia ??
                        r.idProcessoModeloArtefatoDependencia ??
                        r.idModeloArtefatoDependencia ??
                        null
                    )
                    .filter(Boolean)
                    .map(Number)
                    // Dependência desativada não tem card e por isso nunca poderia ser
                    // concluída: mantê-la bloquearia o dependente para sempre.
                    .filter(id => configs[id]?.flAtivo !== false);

                return [...new Set(ids)];
            },

            nomeByModelId(modelId) {
                const item = (this.lstProcessoArtefato || []).find(i => i.idProcessoModeloArtefato === Number(modelId));
                return item?.nmModelo ?? `Artefato ${modelId}`;
            },

            dependenciasNomesByModelId(modelId) {
                const ids = this.depModelIdsByModelId(modelId);
                const nomes = ids.map(id => this.nomeByModelId(id));
                return [...new Set(nomes)];
            },

            dependenciasPendentesNomesByModelId(modelId) {
                const ids = this.depModelIdsByModelId(modelId);
                const byId = new Map((this.lstProcessoArtefato || []).map(i => [i.idProcessoModeloArtefato, i]));
                return ids
                    .filter(id => !byId.get(id)?.flArtefatoFinalizado)
                    .map(id => this.nomeByModelId(id));
            },

            isBloqueado(modelId) {
                const pend = this.dependenciasPendentesNomesByModelId(modelId);
                return pend.length > 0;
            },

            applyDependenciesToCards() {
                if (!Array.isArray(this.lstProcessoArtefato) || this.lstProcessoArtefato.length === 0) return;

                this.lstProcessoArtefato = this.lstProcessoArtefato.map(it => {
                    const bloqueado = this.isBloqueado(it.idProcessoModeloArtefato);
                    const dependencias = this.dependenciasNomesByModelId(it.idProcessoModeloArtefato);
                    const pendentes = this.dependenciasPendentesNomesByModelId(it.idProcessoModeloArtefato);
                    return { ...it, bloqueado, _depsAll: dependencias, _depsPendentes: pendentes };
                });

            },

            tooltipDependencias(modelId) {
                const pend = this.dependenciasPendentesNomesByModelId(modelId);
                const all = this.dependenciasNomesByModelId(modelId);
                if (pend.length) return `Depende de: ${pend.join(', ')}`;
                if (all.length) return `Possui dependências já atendidas: ${all.join(', ')}`;
                return 'Sem dependências';
            },

            cssVarPx(root, name) {
                const raw = getComputedStyle(root).getPropertyValue(name);
                const num = parseFloat(raw);
                return Number.isFinite(num) ? num : 0;
            },
            getHeaderHeightFallback() {
                const el = this.$refs.header?.$el || document.querySelector('header,.appbar,.tyn-appbar,.navbar');
                return el ? el.getBoundingClientRect().height : 0;
            },
            calcAppbarNavHeight() {
                this.$nextTick(() => {
                    // 1) tenta pela CSS var, senão mede o header
                    let appbarH = this.cssVarPx(document.documentElement, '--appbar-height');
                    if (!appbarH) appbarH = this.getHeaderHeightFallback();

                    // 2) mede a navegação se for fixed/sticky
                    const navWrap = this.$refs.navBar;
                    let navH = 0;
                    if (navWrap) {
                        const pos = getComputedStyle(navWrap).position;
                        const isFixedOrSticky = pos === 'fixed' || pos === 'sticky';
                        navH = isFixedOrSticky ? navWrap.getBoundingClientRect().height : 0;
                    }

                    // 3) total
                    this.appbarNavHeight = Math.round(appbarH + navH + 1);

                    // propaga pro :root também
                    document.documentElement.style.setProperty('--appbarnav-height', this.appbarNavHeight + 'px');

                });
            },
            calcAppbarNavHeightDebounced() {
                if (this.calcDebounceTimer) {
                    clearTimeout(this.calcDebounceTimer);
                }
                this.calcDebounceTimer = setTimeout(() => {
                    this.calcAppbarNavHeight();
                }, 150);
            },
            setupResizeObserver() {
                if (typeof ResizeObserver === 'undefined') return;

                // Observa mudanças no tamanho da navegação
                this.navResizeObs = new ResizeObserver(() => {
                    this.calcAppbarNavHeightDebounced();
                });

                if (this.$refs.navBar) {
                    this.navResizeObs.observe(this.$refs.navBar);
                }
            },
            formatQtd(v) {
                if (v === null || v === undefined) return '0'
                try {
                    return Number(v).toLocaleString('pt-BR')
                } catch {
                    return String(v)
                }
            },

            async carregarItensRegistroPorProcesso() {
                if (this.processo?.flAguardando !== true) return;

                this.registroItensLoading = true;
                this.registroItens = [];

                try {
                    const res = await axios.get(
                        `${urlApi}/RegistroNecessidade/GetRegistroNecessidadeItensPorProcesso`,
                        { showLoading: false, params: { idProcesso: this.id } }
                    );

                    if (!res.data?.success) {
                        avisoErro(res.data?.msg || 'Erro ao carregar itens do registro.');
                        return;
                    }

                    const grid = res.data.data;
                    const rows = grid?.rows || grid || [];
                    const arr = Array.isArray(rows) ? rows : [];

                    const lotePadraoId =
                        this.isLoteUnico
                            ? (this.registroLotes?.[0]?.idProcessoItemLote || null)
                            : (this.registroLotes?.[0]?.idProcessoItemLote || null);

                    this.registroItens = arr.map(x => {
                        const it = x?.itemDetalhadoPorProcesso || x;

                        const total = Number(it?.qtdTotalItem);
                        const qtdIniciar = Number.isFinite(total) ? total : null;
                        return {
                            ...it,
                            qtdIniciar,
                            idProcessoItemLoteSelecionado: lotePadraoId, // 👈
                        };
                    });

                } catch (err) {
                    avisoErro(err?.response?.data || err.message || 'Erro ao carregar itens do registro.');
                } finally {
                    this.registroItensLoading = false;
                }
            },

            ajustarQtdIniciar(it) {
                if (!it) return;

                // Se o usuário apagar o campo, mantém como null (para bloquear iniciar)
                if (it.qtdIniciar === '' || it.qtdIniciar === null || it.qtdIniciar === undefined) {
                    it.qtdIniciar = null;
                    return;
                }

                let qtd = Number(it.qtdIniciar);
                const total = Number(it.qtdTotalItem || 0);

                if (!Number.isFinite(qtd)) {
                    it.qtdIniciar = null;
                    return;
                }

                // clamp
                if (qtd < 0) qtd = 0;
                if (qtd > total) qtd = total;

                it.qtdIniciar = qtd;
            },

            payloadRegistroParaIniciar() {
                const isLoteUnico = this.isLoteUnico === true;

                const loteUnicoId = this.registroLotes?.[0]?.idProcessoItemLote || null;

                return (this.registroItens || [])
                    .filter(it => Number(it.qtdTotalItemUtilizada) > 0)
                    .map(it => ({
                        idItem: it.idItem,
                        idUnidadeMedida: Number(it.idUnidadeMedida),
                        qtd: Number(it.qtdTotalItemUtilizada),

                        idProcessoItemLote: isLoteUnico
                            ? loteUnicoId
                            : Number(it.idProcessoItemLote || 0),
                    }));
            },


            confirmarIniciarProcesso() {
                if (!this.registroPodeIniciar) {
                    avisoToast("Preencha as quantidades (válidas) para iniciar o processo.", "warning");
                    return;
                }

                Swal.fire({
                    title: 'Iniciar processo?',
                    html: `<p class="mb-2">
                            Ao avançar para o processo, a <strong>solicitação de Registro de Necessidade será fechada</strong>
                            e, por isso, <strong>não será mais acessível a mudanças</strong>.
                          </p>
                          <p class="mb-0">Deseja continuar?</p>`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sim, iniciar',
                    cancelButtonText: 'Cancelar',
                    confirmButtonColor: '#0d6efd',
                }).then(async (result) => {
                    if (!result.isConfirmed) return;

                    this.registroIniciando = true;
                    try {
                        const itens = this.payloadRegistroParaIniciar();

                        const res = await axios.post(
                            `${urlApi}/RegistroNecessidade/IniciarProcessoFecharRegistros`,
                            { idProcesso: this.id, itens },
                            { showLoading: true }
                        );

                        if (!res.data?.success) {
                            avisoErro(res.data?.msg || 'Não foi possível iniciar o processo.');
                            return;
                        }

                        avisoToast("Solicitação fechada e processo iniciado com sucesso.");
                        this.load();
                    } catch (err) {
                        avisoErro(err?.response?.data || err.message || 'Erro ao iniciar o processo.');
                    } finally {
                        this.registroIniciando = false;
                    }
                });
            },

            confirmarAtualizarDataLimite() {
                Swal.fire({
                    title: 'Atualizar Data de limite?',
                    html: `<p class="mb-2">
            Ao atualizar a <strong>Data de limite</strong>, a <strong>solicitação de Registro de Necessidade poderá ser fechada se a data for menor que hoje</strong>
            e, por isso, <strong>não será mais acessível a mudanças</strong>.
          </p>
          <p class="mb-0">Deseja continuar?</p>`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Sim, alterar',
                    cancelButtonText: 'Cancelar',
                    confirmButtonColor: '#0d6efd',
                }).then(async (result) => {
                    if (!result.isConfirmed) return;

                    try {
                        const res = await axios.post(
                            `${urlApi}/Processo/AlterarDataLimiteRegistroNecessidade`,
                            {
                                idProcesso: this.id,
                                dtLimiteRegistroNecessidade: this.dtLimiteRegistroNecessidade
                            },
                            { showLoading: true }
                        );

                        if (!res.data?.success) {
                            avisoErro(res.data?.msg || 'Não foi possível alterar a Data de limite.');
                            return;
                        }

                        avisoToast("Data de limite alterada com sucesso.");
                        this.load();
                    } catch (err) {
                        avisoErro(err?.response?.data || err.message || 'Erro ao alterada o processo.');
                    }
                });
            },

            VerificaLoteUnico() {
                return axios
                    .get(`${urlApi}/ProcessoItem/VerificaLoteUnico`, {
                        params: { idProcesso: this.id }
                    })
                    .then(res => {
                        const result = res.data?.data || {};
                        this.isLoteUnico = !!result.isLoteUnico;
                    })
                    .catch(() => {
                        this.isLoteUnico = true;
                    });
            },


            abrirDetalhesItem(item) {
                this.detalheItemSelecionado = item
                this.bsModalItensPorSetor?.show?.()
            },
            async carregarLotesProcessoItemLote() {
                if (this.processo?.flAguardando !== true) return;

                const res = await axios.get(`${urlApi}/ProcessoItem/GetProcessoItemLote`, {
                    showLoading: false,
                    params: { idProcesso: this.id, index: 0, take: 1000, orderBy: "nrLote asc" }
                });

                if (!res.data?.success) {
                    avisoErro(res.data?.msg || "Erro ao carregar lotes.");
                    this.registroLotes = this.isLoteUnico ? [{ idProcessoItemLote: 0, nrLote: 1 }] : [];
                    this.loteSelecionado = this.registroLotes[0].idProcessoItemLote;
                    return;
                }

                const grid = res.data.data;
                const rows = grid?.rows || grid || [];
                const arr = Array.isArray(rows) ? rows : [];

                const lotes = arr
                    .map(r => r?.processoItemLote || r)
                    .filter(x => x?.idProcessoItemLote > 0 && x?.nrLote > 0)
                    .map(x => ({ idProcessoItemLote: Number(x.idProcessoItemLote), nrLote: Number(x.nrLote) }));

                // distinct por id
                const map = new Map(lotes.map(x => [x.idProcessoItemLote, x]));
                this.registroLotes = [...map.values()].sort((a, b) => a.nrLote - b.nrLote);
                this.loteSelecionado = this.registroLotes[0].idProcessoItemLote;
            },

            async salvarQuantidadesDetalhes() {
                try {
                    let itens = this.detalheItemSelecionado.porSetor.map(x => {
                        return {
                            idProcessoItemRegistroNecessidadeItem: x.idProcessoItemRegistroNecessidadeItem,
                            qtdItem: x.qtdUtilizada
                        }
                    })

                    const res = await axios.post(
                        `${urlApi}/RegistroNecessidade/PostProcessoItemRegistroNecessidadeItemQtd`,
                        { lstItens : itens },
                        { showLoading: true }
                    );

                    if (!res.data?.success) {
                        avisoErro(res.data?.msg || 'Não foi possível salvar as quantidades.');
                        return;
                    }

                    avisoToast("Quantidades salvas com sucesso.");
                    this.load();
                    this.bsModalItensPorSetor?.hide?.()
                } catch (err) {
                    avisoErro(err?.response?.data || err.message || 'Erro ao salvar as quantidades.');
                } finally {
                    this.registroIniciando = false;
                }
            },

            // MODAL REGISTRO NECESSIDADE
            async getRegistroNecessidade() {
                try {
                    const res = await axios.get(
                        `${urlApi}/RegistroNecessidade/GetRegistroNecessidadeProcesso`,
                        { showLoading: false, params: { idProcesso: this.id } }
                    );

                    if (!res.data?.success) {
                        avisoErro(res.data?.msg || 'Erro ao carregar itens do registro.');
                        return;
                    }

                    const grid = res.data.data;
                    this.dadosRegistroNecessidade = grid?.rows;
                    this.temRegistroNecessidade = grid?.qtdRecords > 0;

                } catch (err) {
                    avisoErro(err?.response?.data || err.message || 'Erro ao carregar registro de necessidades.');
                    this.temRegistroNecessidade = false;
                }
            },

            abrirModalRegistroNecessidade() {
                this.showModalRegistroNecessidade = !this.showModalRegistroNecessidade;
            },
        },

        mounted() {
            this.load();

            if (this.hubConection) {
                this.InitSignalR();
            }
            this.$nextTick(() => {
                const el = document.getElementById('ModalItensPorSetor')
                const bs = window.bootstrap || window.Bootstrap
                if (el && bs?.Modal) {
                    this.bsModalItensPorSetor = new bs.Modal(el)
                }
            })
            this.debounceAtualizarScrollSetas = () => {
                this.$nextTick(() => {
                    this.atualizarScrollSetas();
                    setTimeout(this.atualizarScrollSetas, 250);
                });
            };
            window.addEventListener('resize', this.debounceAtualizarScrollSetas);
            const el = this.$refs.scrollContainer;
            if (el) {
                el.addEventListener('scroll', this.atualizarScrollSetas);
            }
            this.debounceAtualizarScrollSetas();

            // Calcula altura inicial após renderização completa
            this.$nextTick(() => {
                setTimeout(() => {
                    this.calcAppbarNavHeight();
                    this.setupResizeObserver();
                }, 100);
            });

            // Adiciona listeners para recalcular quando necessário
            window.addEventListener('resize', this.calcAppbarNavHeightDebounced);
            window.addEventListener('orientationchange', this.calcAppbarNavHeight);
            window.addEventListener('scroll', this.ocultarTooltipNumeroProcesso, true);
        },
        beforeDestroy() {
            window.removeEventListener('scroll', this.ocultarTooltipNumeroProcesso, true);
            window.removeEventListener('resize', this.debounceAtualizarScrollSetas);
            const el = this.$refs.scrollContainer;
            if (el) {
                el.removeEventListener('scroll', this.atualizarScrollSetas);
            }
            window.removeEventListener('resize', this.calcAppbarNavHeightDebounced);
            window.removeEventListener('orientationchange', this.calcAppbarNavHeight);
            if (this.navResizeObs) this.navResizeObs.disconnect();
            if (this.calcDebounceTimer) clearTimeout(this.calcDebounceTimer);
        },

        watch: {
            artefatosOrdenados() {
                this.$nextTick(() => {
                    this.atualizarScrollSetas();
                    this.calcAppbarNavHeightDebounced();
                });
            },
            reloadGlobal() {
                this.load();
            },
        },

    }
</script>

<style lang="scss" scoped>
    
    /* === TELA BLOQUEIO REGISTRO (showLockRegistro) === */
    .lock-registro-page {
        display: flex;
        min-height: calc(100vh - var(--appbarnav-height, 56px));
        align-items: flex-start;
        justify-content: center;
        background: linear-gradient(160deg, #f0f4ff 0%, #e8eef9 50%, #f5f7fa 100%);
        padding: 2rem 1.5rem;
    }

    .lock-registro-container {
        width: 100%;
        max-width: 1380px;
        margin: 0 auto;
    }

    .lock-registro-card-inner {
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        border-radius: 20px;
        box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
        border: 1px solid rgba(148, 163, 184, 0.15);
        overflow: hidden;
    }

    .lock-registro-header {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        padding: 28px 32px 24px;
        position: relative;
    }

    .lock-registro-header::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 32px;
        right: 32px;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
    }

    .lock-registro-header-icon {
        width: 56px;
        height: 56px;
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(16, 185, 129, 0.12) 100%);
        color: #2563eb;
        flex-shrink: 0;
    }

    .lock-registro-header-text {
        flex: 1;
        min-width: 0;
    }

    .lock-registro-title {
        font-size: 1.5rem;
        font-weight: 700;
        color: #0f172a;
        margin: 0 0 0.5rem;
        line-height: 1.3;
    }

    .lock-registro-desc {
        font-size: 0.95rem;
        color: #475569;
        line-height: 1.55;
        margin: 0;
    }

    .lock-registro-desc strong {
        color: #334155;
    }

    .lock-registro-loading {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 3rem 2rem;
        color: #64748b;
        font-weight: 500;
    }

    .lock-registro-content {
        padding: 28px 32px 32px;
    }

    .lock-registro-table-wrap {
        border-radius: 16px;
        overflow: hidden;
        border: 1px solid rgba(148, 163, 184, 0.2);
    }

    .lock-registro-table {
        width: 100%;
        border-collapse: collapse;
    }

    .lock-registro-table thead {
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    }

    .lock-registro-table th,
    .lock-registro-table td {
        padding: 14px 18px;
        border-bottom: 1px solid rgba(148, 163, 184, 0.16);
        font-size: 14px;
        color: #1e293b;
    }

    .lock-registro-table th {
        font-weight: 700;
        text-transform: uppercase;
        font-size: 12px;
        letter-spacing: 0.45px;
        color: #64748b;
    }

    .lock-registro-table tbody tr:hover {
        background: rgba(59, 130, 246, 0.06);
    }

    .lock-registro-item-name {
        font-weight: 600;
        color: #0f172a;
        font-size: 14px;
        margin-bottom: 4px;
    }

    .lock-registro-item-ref {
        font-size: 13px;
        color: #64748b;
    }

    .lock-registro-badge {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 6px 12px;
        border-radius: 10px;
        font-weight: 700;
        font-size: 13px;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        border: 1px solid rgba(59, 130, 246, 0.3);
        color: #1d4ed8;
    }

    .lock-registro-input {
        border-radius: 10px !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        padding: 8px 12px !important;
        font-size: 14px !important;
        transition: border-color 0.2s ease, box-shadow 0.2s ease;
    }

    .lock-registro-input:focus {
        border-color: rgba(37, 99, 235, 0.6) !important;
        box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1) !important;
        outline: none !important;
    }

    .lock-registro-btn-action {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 8px 14px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 13px;
        border: 2px solid rgba(59, 130, 246, 0.35);
        background: rgba(59, 130, 246, 0.12);
        color: #2563eb;
        cursor: pointer;
        transition: all 0.2s ease;
    }

    .lock-registro-btn-action:hover {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: #ffffff;
        border-color: transparent;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
    }

    .lock-registro-empty {
        padding: 2rem !important;
        text-align: center;
    }

    .lock-registro-empty-content h3 {
        margin: 0 0 0.5rem;
        font-size: 1rem;
        font-weight: 600;
        color: #64748b;
    }

    .lock-registro-empty-content p {
        margin: 0;
        font-size: 0.9rem;
        color: #94a3b8;
    }

    .lock-registro-footer {
        display: flex;
        justify-content: flex-end;
        margin-top: 24px;
        padding-top: 20px;
        border-top: 1px solid rgba(148, 163, 184, 0.2);
    }

    .lock-registro-btn-primary {
        display: inline-flex;
        align-items: center;
        padding: 14px 24px;
        border-radius: 12px;
        font-weight: 700;
        font-size: 14px;
        letter-spacing: 0.3px;
        border: none;
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: #fff;
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.35);
        cursor: pointer;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .lock-registro-btn-primary:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 16px 32px rgba(37, 99, 235, 0.4);
    }

    .lock-registro-btn-primary:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
    }

    /* Modal Itens Por Setor (padrão modern-modal) */
    .modal-itens-setor.modern-modal .modal-modern-content {
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
        min-height: 95vh;
    }

    .modal-itens-setor-dialog {
        /*max-width: 520px;*/
    }

    .modal-itens-setor .modal-modern-header {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        padding: 28px 32px 20px;
        position: relative;
    }

    .modal-itens-setor .modal-modern-header::after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 32px;
        right: 32px;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
    }

    .modal-itens-setor .header-icon {
        width: 56px;
        height: 56px;
        border-radius: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(16, 185, 129, 0.12) 100%);
        color: #2563eb;
        flex-shrink: 0;
    }

    .modal-itens-setor .header-text h2 {
        margin: 0;
        font-size: 1.35rem;
        font-weight: 700;
        color: #0f172a;
    }

    .modal-itens-setor .header-text p {
        margin: 0.35rem 0 0;
        font-size: 14px;
        color: #475569;
        line-height: 1.4;
    }

    .modal-itens-setor .modal-modern-body {
        padding: 24px 32px;
    }

    .modal-itens-setor-info {
        margin-bottom: 20px;
    }

    .modal-itens-setor-info .info-reference {
        font-size: 13px;
        color: #64748b;
    }

    .modal-itens-setor-info .info-total-chip {
        display: inline-flex;
        margin-top: 8px;
        padding: 6px 12px;
        border-radius: 10px;
        font-size: 13px;
        font-weight: 600;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        border: 1px solid rgba(59, 130, 246, 0.3);
        color: #1d4ed8;
    }

    .modal-itens-setor-table .custom-table {
        width: 100%;
        border-collapse: collapse;
        border-radius: 16px;
        overflow: hidden;
        border: 1px solid rgba(148, 163, 184, 0.2);
    }

    .modal-itens-setor-table .custom-table thead {
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    }

    .modal-itens-setor-table .custom-table th,
    .modal-itens-setor-table .custom-table td {
        padding: 14px 18px;
        border-bottom: 1px solid rgba(148, 163, 184, 0.16);
        font-size: 14px;
        color: #1e293b;
    }

    .modal-itens-setor-table .custom-table th {
        font-weight: 700;
        text-transform: uppercase;
        font-size: 12px;
        letter-spacing: 0.45px;
    }

    .modal-itens-setor-table .number-badge {
        display: inline-flex;
        padding: 6px 12px;
        border-radius: 10px;
        font-weight: 700;
        font-size: 13px;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        border: 1px solid rgba(59, 130, 246, 0.3);
        color: #1d4ed8;
    }

    .modal-itens-setor-empty {
        text-align: center;
        padding: 2rem;
    }

    .modal-itens-setor-empty .empty-icon {
        color: #94a3b8;
        margin-bottom: 1rem;
    }

    .modal-itens-setor-empty h3 {
        margin: 0 0 0.5rem;
        font-size: 1.1rem;
        font-weight: 700;
        color: #0f172a;
    }

    .modal-itens-setor-empty p {
        margin: 0;
        font-size: 14px;
        color: #64748b;
    }

    .modal-itens-setor .empty-state {
        padding: 2rem;
        text-align: center;
    }

    .modal-itens-setor .empty-title {
        margin: 0 0 0.5rem;
        font-size: 1rem;
        font-weight: 600;
        color: #64748b;
    }

    .modal-itens-setor .empty-description {
        margin: 0;
        font-size: 13px;
        color: #94a3b8;
    }

    .modal-itens-setor .modal-modern-footer {
        padding: 0 32px 28px;
    }

    .modal-itens-setor .btn-close-modern {
        position: absolute;
        top: 18px;
        right: 18px;
        width: 44px;
        height: 44px;
        border-radius: 50% !important;
        background: #ffffff !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 10px 30px rgba(15, 23, 42, 0.12);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        z-index: 1001;
    }

    .modal-itens-setor .btn-close-modern:hover {
        transform: scale(1.07);
        box-shadow: 0 14px 34px rgba(37, 99, 235, 0.2);
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
        border-color: transparent !important;
    }

    .modal-itens-setor .btn-close-modern svg {
        color: #334155;
    }

    .modal-itens-setor .btn-close-modern:hover svg {
        color: #ffffff;
    }

    .modal-itens-setor .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 12px 22px;
        border-radius: 14px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);
        color: #ffffff;
    }

    .modal-itens-setor .modern-btn:hover {
        transform: translateY(-2px);
    }

    .modal-itens-setor .modern-btn.modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: #fff;
    }

    [data-bs-theme='dark'] .lock-registro-page {
        background: linear-gradient(160deg, #1e293b 0%, #0f172a 50%, #1e293b 100%);
    }

    [data-bs-theme='dark'] .lock-registro-card-inner {
        background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
        border-color: rgba(71, 85, 105, 0.5);
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
    }

    [data-bs-theme='dark'] .lock-registro-header::after {
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.2), transparent);
    }

    [data-bs-theme='dark'] .lock-registro-header-icon {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.18) 0%, rgba(45, 212, 191, 0.18) 100%);
        color: #60a5fa;
    }

    [data-bs-theme='dark'] .lock-registro-title {
        color: #f8fafc;
    }

    [data-bs-theme='dark'] .lock-registro-desc {
        color: #94a3b8;
    }

    [data-bs-theme='dark'] .lock-registro-desc strong {
        color: #cbd5e1;
    }

    [data-bs-theme='dark'] .lock-registro-table thead {
        background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
    }

    [data-bs-theme='dark'] .lock-registro-table th,
    [data-bs-theme='dark'] .lock-registro-table td {
        border-color: rgba(71, 85, 105, 0.4);
        color: #e2e8f0;
    }

    [data-bs-theme='dark'] .lock-registro-table th {
        color: #94a3b8;
    }

    [data-bs-theme='dark'] .lock-registro-item-name {
        color: #f1f5f9;
    }

    [data-bs-theme='dark'] .lock-registro-item-ref {
        color: #94a3b8;
    }

    [data-bs-theme='dark'] .lock-registro-badge {
        background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%);
        border-color: #3b82f6;
        color: #93c5fd;
    }

    [data-bs-theme='dark'] .lock-registro-input {
        background: rgba(15, 23, 42, 0.8) !important;
        border-color: rgba(71, 85, 105, 0.5) !important;
        color: #e2e8f0 !important;
    }

    [data-bs-theme='dark'] .lock-registro-btn-action {
        background: rgba(59, 130, 246, 0.15);
        border-color: rgba(59, 130, 246, 0.35);
        color: #60a5fa;
    }

    [data-bs-theme='dark'] .lock-registro-btn-action:hover {
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        color: #ffffff;
    }

    [data-bs-theme='dark'] .lock-registro-btn-primary {
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.45);
    }

    [data-bs-theme='dark'] .lock-registro-footer {
        border-top-color: rgba(71, 85, 105, 0.4);
    }

    [data-bs-theme='dark'] .modal-itens-setor .modal-modern-content {
        background: linear-gradient(135deg, #0f172a 0%, #111826 100%);
    }

    [data-bs-theme='dark'] .modal-itens-setor .header-icon {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.18) 0%, rgba(45, 212, 191, 0.18) 100%);
        color: #60a5fa;
    }

    [data-bs-theme='dark'] .modal-itens-setor .header-text h2 {
        color: #f8fafc;
    }

    [data-bs-theme='dark'] .modal-itens-setor .header-text p {
        color: #94a3b8;
    }

    [data-bs-theme='dark'] .modal-itens-setor .btn-close-modern {
        background: rgba(15, 23, 42, 0.9) !important;
        border-color: rgba(148, 163, 184, 0.25) !important;
    }

    [data-bs-theme='dark'] .modal-itens-setor .btn-close-modern svg {
        color: #e2e8f0;
    }

    /* === COMPONENTES MODERNOS === */
    h3 {
        font-size: 1.2rem;
        font-weight: 700;
        color: #2d3748;
        margin-bottom: 0.75rem;
        position: relative;
        padding-left: 1rem;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 70%;
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            border-radius: 2px;
        }
    }
    /* Card Moderno */
    .card-artefato {
        position: relative;
        z-index: 999;
    }

    .artefato-scroll-wrapper {
        overflow-x: auto;
        overflow-y: visible !important;
        position: relative;
        padding-inline: 0.3rem;
    }

    .icon-link {
        fill: #2563EB;
        transition: transform 0.2s ease;
    }

    .icon-link:hover {
        transform: scale(1.1);
    }

    [data-bs-theme='dark'] .icon-link {
        fill: #CBD5E1;
    }

    /* Artefatos Container */
    .artefato-container {
        display: flex;
        flex-direction: row;
        gap: 0.75rem;
        overflow-x: auto;
        overflow-y: visible !important;
        scroll-behavior: smooth;
        scrollbar-width: none;
        padding: 0.25rem 0.3rem;
        align-items: center;
        min-height: fit-content;
    }

    .artefato-container::-webkit-scrollbar {
        display: none;
    }

    .artefato-scroll-wrapper {
        padding: 0;
    }

    /* Scroll Buttons Modernos */
    .scroll-btn {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 1003;
        background: white;
        border: 1px solid #e2e8f0;
        width: 48px;
        height: 48px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: #2563eb;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04);
    }

    .scroll-btn.left {
        left: 0.25rem;
    }

    .scroll-btn.right {
        right: 0.25rem;
    }

    .scroll-btn:hover {
        background: #2563eb;
        color: white;
        box-shadow: 0 6px 20px rgba(37, 99, 235, 0.3);
        transform: translateY(-50%) scale(1.1);
        border-color: #2563eb;
    }

    [data-bs-theme='dark'] .scroll-btn {
        background: #1e293b;
        border-color: #334155;
        color: #60a5fa;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    }

    [data-bs-theme='dark'] .scroll-btn:hover {
        background: #3b82f6;
        color: white;
        border-color: #3b82f6;
        box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
    }

    /* Navegação Artefatos */
    .navegacao-artefatos {
        top: var(--appbar-height);
        position: fixed;
        z-index: 999;
        left: 0;
        right: 0;
        border-bottom: 1px solid #e2e8f0;
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(10px);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    }

    .navegacao-artefatos .row {
        margin-left: 0;
        margin-right: 0;
        min-height: fit-content;
    }

    .navegacao-artefatos .col-12 {
        padding-left: 8px;
        padding-right: 8px;
    }

    .navegacao-artefatos .bg-white {
        background-color: white !important;
        border-radius: 0;
    }

    [data-bs-theme='dark'] .navegacao-artefatos .bg-white {
        background-color: rgba(15, 23, 42, 0.95) !important;
    }


    [data-bs-theme='dark'] .navegacao-artefatos {
        background: rgba(15, 23, 42, 0.95);
        border-bottom: 1px solid #1e293b;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
    }

    /* Dropdown Menu Moderno */
    .dropdown-menu-modern {
        border-radius: 12px;
        border: 1px solid #e2e8f0;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.12), 0 4px 12px rgba(0, 0, 0, 0.08);
        animation: slideDown 0.2s ease;
    }

    /*@keyframes slideDown {
        from {
            opacity: 0;
            transform: translateY(-10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }*/

    [data-bs-theme='dark'] .dropdown-menu-modern {
        background: #1e293b;
        border-color: #334155;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.4), 0 4px 12px rgba(0, 0, 0, 0.3);
    }

    .dropdown-menu a {
        transition: all 0.2s ease;
        border-radius: 8px;
        padding: 0.625rem 0.75rem;
        margin: 0.125rem 0;
    }

    .dropdown-menu a:hover {
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        transform: translateX(4px);
    }

    [data-bs-theme='dark'] .dropdown-menu a:hover {
        background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%);
    }

    .dropdown-menu a,
    .dropdown-menu a span,
    .dropdown-menu a svg {
        color: var(--bs-primary) !important;
    }

    [data-bs-theme='dark'] .dropdown-menu a,
    [data-bs-theme='dark'] .dropdown-menu a span {
        color: #cbd5e1 !important;
    }

    /* Card Principal */
    .card {
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        border: 1px solid rgba(226, 232, 240, 0.6);
        border-radius: 16px;
        color: #5C686B;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08), 0 2px 6px rgba(0, 0, 0, 0.04);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .card,
    .card * {
        color: #5C686B !important;
    }

    .card-body {
        padding: 0.875rem !important;
    }

    [data-bs-theme='dark'] .card {
        background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%);
        border: 1px solid rgba(51, 65, 85, 0.6);
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3), 0 2px 6px rgba(0, 0, 0, 0.2);
    }

    [data-bs-theme='dark'] .card:hover {
        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.5), 0 4px 12px rgba(0, 0, 0, 0.3);
    }

    [data-bs-theme='dark'] .card * {
        color: #cbd5e1 !important;
    }

    /* Badges Modernos */
    .badge {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white !important;
        border-radius: 12px;
        font-weight: 500;
        padding: 0.5rem 0.875rem;
        box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);
        transition: all 0.2s ease;
    }

    .badge:hover {
        background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
    }

    .badge.bg-light {
        background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);
        color: #ffffff;
    }

    [data-bs-theme='dark'] .badge {
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        box-shadow: 0 2px 8px rgba(59, 130, 246, 0.3);
    }

    [data-bs-theme='dark'] .badge:hover {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
    }

    /* Badges Sutis - Menos Chamativas */
    .badge-subtle {
        display: inline-block;
        background: rgba(148, 163, 184, 0.12);
        color: #64748b !important;
        border: 1px solid rgba(148, 163, 184, 0.2);
        border-radius: 8px;
        font-weight: 500;
        font-size: 0.75rem;
        padding: 0.35rem 0.65rem;
        transition: all 0.2s ease;
        line-height: 1.2;
    }

    .badge-finalizado {
        background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
        color: #F59E0B !important;
        border: 1px solid #F59E0B;
    }

    .badge-subtle:hover {
        background: rgba(148, 163, 184, 0.18);
        border-color: rgba(148, 163, 184, 0.3);
    }

    [data-bs-theme='dark'] .badge-subtle {
        background: rgba(100, 116, 139, 0.15);
        color: #94a3b8 !important;
        border-color: rgba(100, 116, 139, 0.25);
    }

    [data-bs-theme='dark'] .badge-subtle:hover {
        background: rgba(100, 116, 139, 0.22);
        border-color: rgba(100, 116, 139, 0.35);
    }

    /* Número do Processo em Destaque */
    .numero-processo-destaque {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        font-weight: 800;
        font-size: 1.3em;
        letter-spacing: -0.02em;
        text-shadow: 0 2px 4px rgba(37, 99, 235, 0.1);
    }

    .tyn-media-row {
        min-width: 0;
        overflow: hidden;
    }

    [data-bs-theme='dark'] .numero-processo-destaque {
        background: linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
    }

    /* Nome do Processo com Tooltip */
    .nome-processo-hover {
      
        transition: all 0.2s ease;
    }

    .nome-processo-hover:hover {
        color: #2563eb !important;
    }

    [data-bs-theme='dark'] .nome-processo-hover:hover {
        color: #60a5fa !important;
    }

    .tooltip-numero-processo {
        position: fixed;
        z-index: 1080;
        pointer-events: none;
        background: #1e293b;
        color: #fff;
        font-size: 0.8125rem;
        font-weight: 500;
        line-height: 1.4;
        padding: 0.4rem 0.65rem;
        border-radius: 8px;
        box-shadow: 0 8px 24px rgba(15, 23, 42, 0.22);
        word-break: break-word;
        overflow-wrap: anywhere;
        white-space: normal;
    }

    /* Botões Modernos */
    .btn-modern,
    .btn-light {
        border-radius: 10px;
        font-weight: 500;
        padding: 0.5rem 1rem;
        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        border: 1px solid #e2e8f0;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
    }

    .btn-modern:hover,
    .btn-light:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    }

    .btn-icon-modern {
        border-radius: 10px;
        padding: 0.5rem;
        transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .btn-icon-modern:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    }

    [data-bs-theme='dark'] .btn-light {
        background: linear-gradient(135deg, #334155 0%, #1e293b 100%);
        border-color: #475569;
        color: #cbd5e1;
    }

    [data-bs-theme='dark'] .btn-light:hover,
    [data-bs-theme='dark'] .btn-light:active,
    [data-bs-theme='dark'] .btn-light.show {
        background: linear-gradient(135deg, #475569 0%, #334155 100%);
        fill: #2563EB;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    }

    /* Botões Chamativos */
    .btn-chamativo {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white !important;
        border: none;
        border-radius: 10px;
        font-weight: 600;
        padding: 0.5rem 1rem;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
        position: relative;
        overflow: hidden;
    }

    .btn-chamativo::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 220%;
        height: 220%;
        border-radius: 50%;
        background: rgba(255,255,255,0.30);
        transform: translate(-50%, -50%) scale(0);
        transition: transform .6s ease;
        pointer-events: none;
    }

    .btn-chamativo:hover::before {
        transform: translate(-50%, -50%) scale(1);
    }

    .btn-chamativo:hover {
        background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4);
    }

    .btn-chamativo:active {
        transform: translateY(0);
    }

    [data-bs-theme='dark'] .btn-chamativo {
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
    }

    [data-bs-theme='dark'] .btn-chamativo:hover {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        box-shadow: 0 6px 20px rgba(59, 130, 246, 0.5);
    }

    .btn-icon-chamativo {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white !important;
        border: none;
        border-radius: 10px;
        padding: 0.5rem;
        width: 38px;
        height: 38px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.3);
        position: relative;
        overflow: hidden;
    }

    .btn-icon-chamativo::before {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 220%;
        height: 220%;
        border-radius: 50%;
        background: rgba(255,255,255,0.30);
        transform: translate(-50%, -50%) scale(0);
        transition: transform .6s ease;
        pointer-events: none;
    }

    .btn-icon-chamativo:hover::before {
        transform: translate(-50%, -50%) scale(1);
    }

    .btn-icon-chamativo:hover {
        background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
        transform: translateY(-2px) rotate(90deg);
        box-shadow: 0 6px 20px rgba(37, 99, 235, 0.4);
    }

    .btn-icon-chamativo:active {
        transform: translateY(0) rotate(90deg);
    }

    .btn-icon-chamativo svg {
        color: white !important;
        transition: all 0.3s ease;
    }

    [data-bs-theme='dark'] .btn-icon-chamativo {
        background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
    }

    [data-bs-theme='dark'] .btn-icon-chamativo:hover {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        box-shadow: 0 6px 20px rgba(59, 130, 246, 0.5);
    }

    /* Tipografia Melhorada */
    .name.txt-bold {
        font-weight: 700;
        letter-spacing: -0.02em;
    }

    .icone-svg svg {
        width: 24px;
        height: 24px;
        fill: currentColor;
    }

    .tyn-content {
        padding-top: var(--appbarnav-height);
        z-index: 998;
    }

    /* Responsividade */
    @media (max-width: 767px) {
        .navegacao-artefatos .row {
            flex-direction: column;
            gap: 0.5rem;
        }

        .navegacao-artefatos .col-xl-9,
        .navegacao-artefatos .col-xl-3 {
            max-width: 100%;
            flex: 0 0 100%;
        }

        .navegacao-artefatos .bg-white {
            padding: 0.75rem !important;
            border-radius: 0 !important;
        }

        .artefato-container {
            gap: 0.5rem;
            padding: 0.25rem 0.3rem;
            overflow-x: auto;
            flex-wrap: nowrap;
        }

        .scroll-btn {
            display: none;
        }

        .card {
            width: 100% !important;
            min-width: auto !important;
            margin: 0 !important;
            border-radius: 12px;
        }

        .card-body {
            padding: 0.75rem !important;
        }

        .item-artefato {
            flex: 0 0 50%;
            max-width: 50%;
            margin-top: 5px;
        }

        .item-artefato h6 {
            font-size: 0.75rem;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .navegacao-artefatos {
            position: static !important;
            margin-top: 60px;
            border-bottom: 1px solid #cbd5e1;
            background: white !important;
        }

        [data-bs-theme='dark'] .navegacao-artefatos {
            background: #0f172a !important;
            border-bottom: 1px solid #1e293b;
        }

        .tyn-content {
            padding-top: 0 !important;
            display: flex !important;
            flex-direction: column !important;
        }

        .tyn-content .tyn-aside-base {
            order: 1;
        }

        .tyn-content .tyn-main {
            order: 2;
        }

        .dropdown-menu-end {
            right: 0 !important;
            left: auto !important;
        }

        .badge {
            font-size: 0.75rem;
            padding: 0.375rem 0.625rem;
        }
    }

    @media (min-width: 768px) and (max-width: 1300px) {
        .navegacao-artefatos .row {
            flex-direction: column;
            gap: 0.5rem;
            align-items: stretch;
        }

        .navegacao-artefatos .col-xl-9,
        .navegacao-artefatos .col-xl-3,
        .navegacao-artefatos .col-md-6 {
            max-width: 100% !important;
            flex: 0 0 100% !important;
        }

        .navegacao-artefatos .bg-white {
            padding: 0.875rem !important;
            border-radius: 0 !important;
        }

        .card {
            width: 100% !important;
            min-width: auto !important;
            max-width: 100%;
            margin: 0 !important;
        }

        .card-body {
            padding: 0.875rem !important;
        }

        .navegacao-artefatos {
            position: static !important;
            margin-top: 55px;
            background: white !important;
        }

        [data-bs-theme='dark'] .navegacao-artefatos {
            background: #0f172a !important;
        }

        .tyn-content {
            padding-top: 0 !important;
            display: flex !important;
            flex-direction: column !important;
        }

        .tyn-content .tyn-aside-base {
            order: 1;
        }

        .tyn-content .tyn-main {
            order: 2;
        }
    }

    /* ========================================
       ESTILOS MODERNOS PARA CHAT - PROCESSO
       ======================================== */
    
    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes pulse {
        0%, 100% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.02);
        }
    }

    @keyframes shimmer {
        0% {
            background-position: -1000px 0;
        }
        100% {
            background-position: 1000px 0;
        }
    }

    .chat-input-modern {
        background: linear-gradient(135deg, rgba(248, 249, 250, 0.95) 0%, rgba(233, 236, 239, 0.95) 100%);
        backdrop-filter: blur(10px);
        border: 2px solid rgba(31, 123, 255, 0.15);
        border-radius: 20px;
        padding: 1.5rem;
        margin-bottom: 2rem;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1), 
                    0 4px 12px rgba(31, 123, 255, 0.15);
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        animation: fadeInUp 0.5s ease-out;

        &:hover {
            box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15), 
                        0 6px 16px rgba(31, 123, 255, 0.25);
            border-color: rgba(31, 123, 255, 0.3);
            transform: translateY(-2px);
        }

        &:focus-within {
            border-color: #1f7bff;
            box-shadow: 0 15px 45px rgba(31, 123, 255, 0.2), 
                        0 0 0 4px rgba(31, 123, 255, 0.1);
            transform: translateY(-3px);
        }
    }

    .chat-input-wrapper {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    .form-group-modern {
        position: relative;
        display: flex;
        flex-direction: column;
    }

    .form-control-modern {
        width: 100%;
        padding: 1rem 1.25rem;
        border: 2px solid #e9ecef;
        border-radius: 14px;
        font-size: 1rem;
        line-height: 1.6;
        color: #2d3748;
        background-color: #ffffff;
        resize: vertical;
        min-height: 80px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        font-family: inherit;

        &::placeholder {
            color: #a0aec0;
            opacity: 1;
        }

        &:hover:not(:focus) {
            border-color: #cbd5e0;
            background-color: #f8f9fa;
        }

        &:focus {
            outline: none;
            border-color: #1f7bff;
            background-color: #ffffff;
            box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.1),
                        0 4px 12px rgba(31, 123, 255, 0.15);
            transform: translateY(-1px);
        }

        &:disabled {
            background-color: #f1f3f5;
            cursor: not-allowed;
            opacity: 0.6;
        }
    }

    .char-counter {
        position: absolute;
        bottom: 8px;
        right: 12px;
        font-size: 0.75rem;
        color: #6c757d;
        background: rgba(255, 255, 255, 0.9);
        padding: 0.25rem 0.5rem;
        border-radius: 6px;
        font-weight: 500;
        pointer-events: none;
        transition: color 0.3s ease;
    }

    .form-control-modern:focus ~ .char-counter {
        color: #1f7bff;
    }

    .btn-send-modern {
        align-self: flex-end;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0.875rem 2rem;
        background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
        color: white;
        border: none;
        border-radius: 14px;
        font-size: 1rem;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 6px 20px rgba(31, 123, 255, 0.3);
        position: relative;
        overflow: hidden;
        min-width: 180px;

        &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 0;
            height: 0;
            border-radius: 50%;
            background: rgba(255, 255, 255, 0.3);
            transform: translate(-50%, -50%);
            transition: width 0.6s ease, height 0.6s ease;
        }

        &:hover:not(:disabled)::before {
            width: 300px;
            height: 300px;
        }

        &:hover:not(:disabled) {
            background: linear-gradient(135deg, #4a94ff 0%, #00d084 100%);
            box-shadow: 0 10px 30px rgba(31, 123, 255, 0.4),
                        0 0 20px rgba(0, 208, 132, 0.3);
            transform: translateY(-3px) scale(1.02);
        }

        &:active:not(:disabled) {
            transform: translateY(-1px) scale(0.98);
            box-shadow: 0 4px 15px rgba(31, 123, 255, 0.4);
        }

        &:disabled {
            background: linear-gradient(135deg, #cbd5e0 0%, #a0aec0 100%);
            cursor: not-allowed;
            opacity: 0.6;
            box-shadow: none;
            transform: none !important;
        }

        i, span {
            position: relative;
            z-index: 1;
        }

        i {
            font-size: 1.1rem;
            transition: transform 0.3s ease;
        }

        &:hover:not(:disabled) i {
            transform: translateX(3px);
        }
    }

    /* Melhorias nas mensagens do chat */
    .tyn-qa-message {
        transition: all 0.3s ease;
        
        &.bg-question {
            background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%) !important;
            border-left: 4px solid #1f7bff;
            box-shadow: 0 2px 8px rgba(31, 123, 255, 0.15);
        }

        &.bg-response {
            background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%) !important;
            border-left: 4px solid #00d084;
            box-shadow: 0 2px 8px rgba(0, 208, 132, 0.15);
        }
    }

    /* Botões de opções modernos */
    .btn-outline-primary {
        border: 2px solid #1f7bff;
        color: #1f7bff;
        background: transparent;
        border-radius: 12px;
        padding: 0.65rem 1.5rem;
        font-weight: 600;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(31, 123, 255, 0.1);
        display: inline-flex;
        align-items: center;
        gap: 0.5rem;

        &:hover {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            border-color: transparent;
            color: white;
            box-shadow: 0 6px 20px rgba(31, 123, 255, 0.3);
            transform: translateY(-2px);

            svg {
                transform: rotate(90deg) scale(1.1);
            }
        }

        &:active {
            transform: translateY(0);
        }

        svg {
            transition: transform 0.3s ease;
        }
    }

    /* Progress bar moderna */
    .progress {
        height: 8px;
        border-radius: 10px;
        background: rgba(233, 236, 239, 0.5);
        overflow: hidden;
        box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    .progress-bar {
        border-radius: 10px;
        background: linear-gradient(90deg, #1f7bff 0%, #00d084 100%);
        background-size: 200% 100%;
        animation: shimmer 2s linear infinite;
        box-shadow: 0 2px 8px rgba(31, 123, 255, 0.4);
    }

    /* Animações para mensagens de erro */
    .text-danger {
        animation: pulse 2s ease-in-out infinite;
    }

    /* Melhorias nos radio buttons */
    input[type="radio"] {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        width: 1.25rem;
        height: 1.25rem;
        border: 2px solid #cbd5e0;
        border-radius: 50%;
        outline: none;
        transition: all 0.3s ease;
        cursor: pointer;
        position: relative;
        background: white;
        flex-shrink: 0;

        &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) scale(0);
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background: white;
            transition: transform 0.2s ease;
        }

        &:checked {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            border-color: #1f7bff;
            box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.15);

            &::before {
                transform: translate(-50%, -50%) scale(1);
            }
        }

        &:hover:not(:disabled) {
            border-color: #1f7bff;
            transform: scale(1.1);
        }

        &:focus {
            outline: none;
            box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.15);
        }

        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
            background: #f1f3f5;
        }
    }

    label {
        cursor: pointer;
        transition: color 0.3s ease;
        user-select: none;

        &:hover {
            color: #1f7bff;
        }
    }

    /* Dropdown de ações melhorado */
    .dropdown-menu.acoes {
        border-radius: 12px;
        border: 2px solid rgba(31, 123, 255, 0.15);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
        padding: 0.5rem;
        background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);

        .dropdown-item {
            border-radius: 8px;
            padding: 0.65rem 1rem;
            transition: all 0.2s ease;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            margin-bottom: 0.25rem;

            &:hover {
                background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
                color: white;
                transform: translateX(4px);

                svg {
                    transform: scale(1.1);
                }
            }

            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    /* Botão de dropdown melhorado */
    .btn-icon.btn-light.dropdown-toggle {
        border-radius: 10px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        border: 2px solid #e9ecef;
        background: white;
        width: 38px;
        height: 38px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0;
        position: relative;
        overflow: hidden;

        svg {
            transition: all 0.3s ease;
            fill: #6c757d;
        }

        &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 0;
            height: 0;
            border-radius: 50%;
            background: rgba(31, 123, 255, 0.1);
            transform: translate(-50%, -50%);
            transition: width 0.4s ease, height 0.4s ease;
        }

        &:hover::before {
            width: 200%;
            height: 200%;
        }

        &:hover {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            border-color: transparent;
            transform: scale(1.08) rotate(90deg);
            box-shadow: 0 4px 12px rgba(31, 123, 255, 0.3);
            
            svg {
                fill: white !important;
                color: white !important;
            }
        }

        &:active {
            transform: scale(1.02) rotate(90deg);
        }

        &.show {
            background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
            border-color: transparent;
            transform: rotate(90deg);

            svg {
                fill: white !important;
                color: white !important;
            }
        }
    }

    .form-group {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .form-group-inline {
        display: flex;
        align-items: center;
        gap: 16px;
        flex-wrap: wrap;
    }

    .form-group-inline .info-chip {
        display: inline-flex;
        align-items: flex-start;
        gap: 8px;
        padding: 12px 16px;
        border-radius: 12px;
        background: rgba(37, 99, 235, 0.08);
        color: #1e3a8a;
        font-size: 13px;
        line-height: 1.4;
        max-width: 380px;
    }

    /* Responsivo para chat */
    @media (max-width: 768px) {
        .chat-input-modern {
            padding: 1rem;
            border-radius: 16px;
            margin-bottom: 1.5rem;
        }

        .form-control-modern {
            padding: 0.875rem 1rem;
            font-size: 0.95rem;
            border-radius: 12px;
        }

        .btn-send-modern {
            width: 100%;
            padding: 0.75rem 1.5rem;
            font-size: 0.95rem;
            min-width: unset;
        }

        .char-counter {
            font-size: 0.7rem;
            bottom: 6px;
            right: 10px;
        }

        .btn-outline-primary {
            width: 100%;
            justify-content: center;
            padding: 0.75rem 1.5rem;
        }
    }

    @media (max-width: 576px) {
        .chat-input-modern {
            padding: 0.875rem;
            border-radius: 14px;
        }

        .chat-input-wrapper {
            gap: 0.75rem;
        }

        .form-control-modern {
            padding: 0.75rem 0.875rem;
            font-size: 0.9rem;
            min-height: 70px;
        }

        .btn-send-modern {
            padding: 0.7rem 1.25rem;
            font-size: 0.9rem;
            border-radius: 12px;

            i {
                font-size: 1rem;
            }
        }

        .btn-outline-primary {
            font-size: 0.9rem;
            padding: 0.7rem 1.25rem;
        }
    }

    /* ============================================
   DARK THEME - Consulta
   ============================================ */

    [data-bs-theme="dark"] .chat-input-modern {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        border-color: rgba(96, 165, 250, 0.25);
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4), 0 4px 12px rgba(96, 165, 250, 0.2);

        &:hover {
            box-shadow: 0 15px 40px rgba(0, 0, 0, 0.5), 0 6px 16px rgba(96, 165, 250, 0.3);
            border-color: rgba(96, 165, 250, 0.35);
        }

        &:focus-within {
            background: linear-gradient(135deg, #252b3d 0%, #2d3548 100%);
            border-color: #60a5fa;
            box-shadow: 0 15px 45px rgba(96, 165, 250, 0.3), 0 0 0 4px rgba(96, 165, 250, 0.15);
        }
    }

    [data-bs-theme="dark"] .form-control-modern {
        background: #0f1117;
        border-color: rgba(255, 255, 255, 0.12);
        color: #f3f4f6;

        &::placeholder {
            color: #6b7280;
        }

        &:hover:not(:focus) {
            border-color: rgba(255, 255, 255, 0.2);
            background: #1a1d29;
        }

        &:focus {
            background: #1a1d29;
            border-color: #60a5fa;
            color: #ffffff;
            box-shadow: 0 0 0 4px rgba(96, 165, 250, 0.15), 0 4px 12px rgba(96, 165, 250, 0.2);
        }

        &:disabled {
            background: #1a1d29;
            color: #6b7280;
        }
    }

    [data-bs-theme="dark"] .char-counter {
        background: rgba(30, 35, 48, 0.9);
        color: #d1d5db;
    }

    [data-bs-theme="dark"] .form-control-modern:focus ~ .char-counter {
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .btn-send-modern {
        background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
        box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);

        &:hover:not(:disabled) {
            background: linear-gradient(135deg, #60a5fa 0%, #34d399 100%);
            box-shadow: 0 10px 30px rgba(59, 130, 246, 0.5), 0 0 20px rgba(16, 185, 129, 0.4);
        }

        &:disabled {
            background: linear-gradient(135deg, #374151 0%, #4b5563 100%);
        }
    }

    [data-bs-theme="dark"] .tyn-qa-message.bg-question {
        background: linear-gradient(135deg, #1e3a8a 0%, #1e40af 100%) !important;
        border-left-color: #60a5fa;
        box-shadow: 0 2px 8px rgba(59, 130, 246, 0.2);
        color: #e0f2fe;
    }

    [data-bs-theme="dark"] .tyn-qa-message.bg-response {
        background: linear-gradient(135deg, #064e3b 0%, #065f46 100%) !important;
        border-left-color: #34d399;
        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.2);
        color: #d1fae5;
    }

    [data-bs-theme="dark"] .btn-outline-primary {
        border-color: #3b82f6;
        color: #60a5fa;
        background: transparent;

        &:hover {
            background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
            color: white;
            box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4);
        }
    }

    [data-bs-theme="dark"] .progress {
        background: #0f1117;
    }

    [data-bs-theme="dark"] .progress-bar {
        background: linear-gradient(90deg, #3b82f6 0%, #10b981 100%);
    }

    [data-bs-theme="dark"] .form-check-input {
        background: #0f1117;
        border-color: rgba(255, 255, 255, 0.2);

        &:checked {
            background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
            border-color: #3b82f6;
        }

        &:disabled {
            background: #1a1d29;
        }
    }

    [data-bs-theme="dark"] .form-check-label {
        color: #e5e7eb;

        &:hover {
            color: #60a5fa;
        }
    }

    [data-bs-theme="dark"] .c-pointer {
        color: #60a5fa;

        &:hover {
            color: #34d399;
        }
    }

    [data-bs-theme="dark"] .item-fonte {
        background: rgba(59, 130, 246, 0.15);
        border-color: rgba(59, 130, 246, 0.3);
        color: #93c5fd;

        &:hover {
            background: rgba(59, 130, 246, 0.25);
        }
    }

    [data-bs-theme="dark"] .dropdown-menu.acoes {
        background: linear-gradient(135deg, #1e2330 0%, #252b3d 100%);
        border-color: rgba(96, 165, 250, 0.2);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);

        .dropdown-item {
            color: #e5e7eb;

            &:hover {
                background: linear-gradient(135deg, #3b82f6 0%, #10b981 100%);
                color: white;
            }
        }
    }

    [data-bs-theme="dark"] .referencias {
        color: #e5e7eb;

        strong {
            color: #f9fafb;
        }

        p {
            color: #e5e7eb;
        }

        a {
            color: #60a5fa;
        }
    }

    [data-bs-theme="dark"] :deep(.form-control) {
        background: #0f1117;
        border-color: rgba(255, 255, 255, 0.12);
        color: #f3f4f6;

        &:hover:not(:focus) {
            background: #1a1d29;
        }

        &:focus {
            background: #1a1d29;
            border-color: #60a5fa;
            color: #ffffff;
        }
    }

    [data-bs-theme="dark"] :deep(.btn-primary) {
        background: linear-gradient(135deg, #2563eb 0%, #1e40af 100%);

        &:hover {
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
        }
    }

    [data-bs-theme="dark"] .tyn-qa-message p,
    [data-bs-theme="dark"] .tyn-qa-message strong {
        color: inherit;
    }
</style>